<template>
  <div>
    <login-dialog
      v-if="loginDailogShow"
      :isWeb="true"
      @hide="loginDailogClick"
    />
    <div class="topP">
      <div class="top">
        <div
          class="topSubP"
          ref="topSubP"
        >
          <div class="topSub">
            <div class="topLLP">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812154220.png"
              />
              <div>微脉输入法 话术管理后台</div>
            </div>
            <div class="topRP">
              <div class="topRP">
                <div
                  class="topRL"
                  @click="go2download"
                >
                  <img
                    src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812174905.png"
                  />下载PC端，支持发话术
                </div>
                <div class="topLLItemLine"></div>
                <div
                  class="topRR2"
                  @click="loginDailogClick"
                >
                  <img
                    v-if="faceIcon && faceIcon.length"
                    class="header-main-top"
                    :src="faceIcon"
                  />
                  <img
                    v-else
                    class="header-main-top"
                    src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"
                  />
                  <div>{{ userName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="topBP">
        <div class="topB">
          <div class="topLP">当前团队</div>
          <div class="topRP">
            <div
              v-if="huashuTeamList.length"
              class="topL"
            >
              <img
                v-if="huashuTeamList[teamSelIdx].roleId == 2"
                class="topLL"
                src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png"
              />
              <div class="topLR">{{ huashuTeamList[teamSelIdx].showName }}</div>
            </div>
            <div class="topR">
              <img
                class="topRL2"
                src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png"
                @click="changeTeam"
              />
              <div
                class="topRR"
                @click="changeTeam"
              >
                切换团队
              </div>
            </div>
          </div>
        </div>
        <div class="searchAreaP">
          <div class="searchArea">
            <!-- <div
              class="searchAreaBarTitle"
              @click="cancelSearch"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250918104542.png"
              />返回
            </div> -->
            <div class="searchAreaBar">
              <img
                src="https://imagessl.edujia.com/A-1ed71af7_20240219112835.png"
              />
              <input
                v-model="keywords"
                placeholder="输入关键词搜索"
                type="text"
              />
              <img
                v-if="keywords.length"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250917183423.png"
                @click="keywords = ''"
              />
            </div>
            <div
              class="searchAreaBtn"
              @click="searchBtnClick"
            >
              搜索
            </div>
          </div>
          <div
            class="huashuDetailTitleRightR"
            @click="go2review"
          >
            待审核话术
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="teamListShow"
      class="teamListCover"
    >
      <div
        class="listAdd listAdd2"
        @click="createTeam"
      >
        <img
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812095807.png"
        />新建团队
      </div>
      <div class="teamListP">
        <div
          v-if="tabIndex == 0"
          class="teamList"
        >
          <div
            v-for="(item, idx) in huashuTeamList"
            :key="'huashuTeamListItem' + idx"
            :class="
              idx == teamSelIdx
                ? 'teamListItemSel teamListItem'
                : 'teamListItem'
            "
            @click="teamItemClick(idx)"
          >
            <img
              v-if="item.roleId == 1"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"
            />
            <img
              v-else-if="item.roleId == 2"
              src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"
            />
            <div>{{ item.showName }}</div>
          </div>
        </div>
        <div
          v-else-if="tabIndex == 1"
          class="teamList"
        >
          <div
            v-for="(item, idx) in themeList"
            :key="'themeListItem' + idx"
            :class="
              idx == themeSelIdx
                ? 'teamListItemSel teamListItem'
                : 'teamListItem'
            "
            @click="themeItemClick(idx)"
          >
            <!-- <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"/>
                        <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"/> -->
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <img
        src="https://imagessl.lingtuo.cn/A-1ed71af7_20250919100121.png"
        class="themeListCloseBtn"
        @click="hideTeamList"
      />
      <!-- <div class="shouqiBtnP">
        <div
          class="shouqiBtn"
          @click="hideTeamList"
        >
          收起<img
            src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png"
          />
        </div>
      </div> -->
    </div>
    <div class="content">
      <div
        class="typeList"
        ref="typeList"
      >
        <div :style="{ display: 'flex' }">
          <div
            v-show="false"
            :style="{
              width: '200px',
              height: '100%',
              overflow: 'scroll',
              'margin-left': '16px',
            }"
          >
            <div class="listTile">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250811181849.png"
              />
              团队列表
            </div>

            <div
              class="listAdd typeListItem"
              @click="createTeam"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812095807.png"
              />创建团队
            </div>
            <div class="listGray">
              <!-- <div
                v-for="(item, idx) in huashuTeamList"
                :class="
                  teamSelIdx == idx
                    ? 'typeListItemSel typeListItem'
                    : 'typeListItem'
                "
                :key="'huashuType' + idx"
                @click="teamItemClick(idx)"
                @contextmenu.prevent="showTypeMenu($event, item, idx)"
              > -->
              <div
                v-for="(item, idx) in huashuTeamList"
                :class="
                  teamSelIdx == idx
                    ? 'typeListItemSel typeListItem'
                    : 'typeListItem'
                "
                :key="'huashuType' + idx"
                @click="teamItemClick(idx)"
              >
                <span
                  v-if="item.roleId == 2"
                  class="teamIcon"
                >
                  创
                </span>
                <span
                  v-else-if="item.roleId == 1"
                  class="teamIcon2"
                >
                  管
                </span>
                <div>{{ item.showName }}</div>
              </div>
            </div>
          </div>
          <div
            v-if="!isSeaching"
            :style="{
              width: '200px',
              height: '100%',
              overflow: 'scroll',
              'margin-left': '8px',
            }"
          >
            <div class="listTile">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250811182044.png"
              />
              话术分类
            </div>
            <div
              class="listAdd typeListItem"
              @click="addHuashuType"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812095807.png"
              />添加分类
            </div>
            <div
              class="listGray"
              @scroll="typeOnScroll"
            >
              <div
                v-for="(item, idx) in typeList"
                :class="
                  typeSelIdx == idx
                    ? 'typeListItemSel typeListItem'
                    : 'typeListItem'
                "
                :key="'huashuType' + idx"
                @click="huashuTypeClick(idx)"
                @contextmenu.prevent="showTypeMenu($event, item, idx)"
              >
                <div>{{ item.labelName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isSeaching"
        class="searching"
      >
        <div
          class="searchAreaBarTitle"
          @click="cancelSearch"
        >
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20250918104542.png"
          />返回话术
        </div>
        <div
          class="huashuList huashuListSearching"
          ref="huashuList"
          @scroll="huashuOnScroll"
        >
          <div
            v-if="countTopHuashu && !isSeaching"
            class="topBar"
            @click="openTopHuashu"
          >
            <div class="topBarL">
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826161724.png"
              />置顶话术 {{ countTopHuashu }}条
            </div>
            <img
              v-if="!huashuTopBarShow"
              class="topBarR"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101203.png"
            />
            <img
              v-else
              class="topBarR"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20240708100936.png"
            />
          </div>
          <div
            class="huashuListItemP"
            v-for="(item, idx) in showHuashuList"
            :key="'showHuashuList' + item.id + idx"
            :style="{ 'background-color': getHuashuItemBgColor(item, idx) }"
          >
            <div
              v-if="huashuBatState"
              class="huashuListItemActionIcon"
              @click="selectHuashu(item, idx)"
            >
              <img
                v-if="!item.select"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812181908.png"
              />
              <img
                v-else
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812180929.png"
              />
            </div>
            <div
              class="huashuListItem"
              :key="'showHuashuList' + item.id + idx"
            >
              <div
                v-if="item.title"
                class="huashuListItemTop"
              >
                <img
                  class="huashuListItemTopL"
                  src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"
                />
                <div class="huashuListItemTopM">
                  {{ item.title }}
                </div>
                <img
                  v-if="item.imglist && item.imglist.length"
                  class="huashuListItemTopR"
                  src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                  @click="go2ImageList(idx)"
                />
                <img
                  v-else-if="item.filelist && item.filelist.length"
                  class="huashuListItemTopR"
                  src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                  @click="go2ImageList(idx)"
                />
              </div>
              <div
                :ref="item.id"
                class="huashuListItemDetailNoHide"
                v-html="item.allText"
              ></div>
              <div v-if="item.title">
                <!-- <div
                    :class="
                      item.showBtn && item.showBtn == 'shouqi'
                        ? 'huashuListItemDetailShowmore'
                        : 'huashuListItemDetail'
                    "
                    :style="{
                      '-webkit-line-clamp':
                        wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                    }"
                    :ref="'show' + item.id"
                    @click="textShowClick(idx)"
                    @dblclick="itemClick(idx, true)"
                    v-html="item.allText"
                  ></div> -->
                <div
                  :class="
                    item.showBtn && item.showBtn == 'shouqi'
                      ? 'huashuListItemDetailShowmore'
                      : 'huashuListItemDetail'
                  "
                  :style="{
                    '-webkit-line-clamp':
                      wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                  }"
                  :ref="'show' + item.id"
                  @mousedown="itemMouseDown"
                  @mousemove="itemMouseMove"
                  @mouseup="itemMouseUp($event, idx)"
                  v-html="searchAllText(item.allText)"
                ></div>
              </div>
              <div v-else>
                <!-- <div
                    class="huashuListItemDetail huashuListItemDetailNoTitle"
                    :ref="'show' + item.id"
                    :style="{
                      'text-indent':
                        (item.imglist && item.imglist.length) ||
                        (item.filelist && item.filelist.length)
                          ? '26px'
                          : 0,
                      display:
                        item.showBtn && item.showBtn == 'shouqi'
                          ? 'block'
                          : '-webkit-box',
                      '-webkit-line-clamp':
                        wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                    }"
                    @click="textShowClick(idx)"
                    @dblclick="itemClick(idx, true)"
                    v-html="item.allText"
                  ></div> -->
                <div
                  :class="
                    item.showBtn && item.showBtn == 'shouqi'
                      ? 'huashuListItemDetailShowmore huashuListItemDetailNoTitle'
                      : 'huashuListItemDetail huashuListItemDetailNoTitle'
                  "
                  :style="{
                    '-webkit-line-clamp':
                      wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                  }"
                  :ref="'show' + item.id"
                  @mousedown="itemMouseDown"
                  @mousemove="itemMouseMove"
                  @mouseup="itemMouseUp($event, idx)"
                  v-html="searchAllText(item.allText)"
                ></div>
              </div>
              <div
                v-if="!huashuBatState"
                class="huashuPs"
              >
                <div class="actionBar">
                  <div
                    class="actionBarItem"
                    @click="editHuashu(item)"
                  >
                    编辑
                  </div>
                  <div
                    class="actionBarItem"
                    @click="moveHuashu2First(item)"
                  >
                    刷新
                  </div>
                  <div
                    class="actionBarItem"
                    @click="setHuashuTop(item)"
                  >
                    {{ item.isTop ? "取消置顶" : "置顶" }}
                  </div>
                  <div
                    class="actionBarItem"
                    @click="removeHuashu(item)"
                  >
                    删除
                  </div>
                </div>
                <!-- <div
                    v-if="item.showBtn == 'zhankai' && !hoverPreviewCheck"
                    class="actionBtn"
                    @click.stop="textShowClick(idx)"
                  >
                    <img
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812173851.png"
                    />
                    展开
                  </div>
                  <div
                    v-else-if="item.showBtn == 'shouqi' && !hoverPreviewCheck"
                    class="actionBtn"
                    @click.stop="textShowClick(idx)"
                  >
                    <img
                      :style="{ transform: 'rotate(180deg)' }"
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812173851.png"
                    />
                    收起
                  </div> -->
              </div>
            </div>
          </div>
          <!-- <huashu-item-right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]" :menuData="menuData" @edit="editHuashu" @remove="removeHuashu" @hideMenu="hideMenu"></huashu-item-right-menu> -->
        </div>
      </div>
      <div v-if="!isSeaching">
        <div class="huashuDetailTitleP">
          <div class="huashuDetailTitle">
            <img
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812142605.png"
            />话术详情
          </div>
          <!-- <div class="huashuDetailTitleRight">
            <div
              class="huashuDetailTitleRightL"
              @click="searchBtnClick"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250917175624.png"
              />
              <div>搜索话术</div>
            </div>
            <div
              class="huashuDetailTitleRightR"
              @click="go2review"
            >
              待审核话术
            </div>
          </div> -->
        </div>
        <div class="huashuDetailTitleP2">
          <div class="huashuDetailTitleP2L">
            <div
              class="actionBtn1"
              @click="addHuashu"
            >
              添加话术
            </div>
            <div
              class="actionBtn2"
              @click="importHuashu"
            >
              文档导入话术
            </div>
          </div>
          <div class="huashuDetailTitleP2R">
            <img
              v-if="!huashuBatState"
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812145610.png"
            />
            <div
              v-if="!huashuBatState"
              @click="huashuBat"
            >
              批量管理
            </div>
            <div
              v-else
              @click="huashuBatCompelete"
            >
              完成管理
            </div>
          </div>
        </div>
        <div
          v-if="huashuBatState"
          class="huashuBatBar"
        >
          <div class="huashuBatBarL">
            <div class="huashuBatBarLL">已选{{ selectHuashuCount }}条话术</div>
            <div
              class="huashuBatBarLR"
              @click="huashuSelectAll"
            >
              全选/全不选
            </div>
          </div>
          <div class="huashuBatBarR">
            <div class="actionBar">
              <div
                class="actionBarItem"
                @click="changeHuashuType()"
              >
                移动
              </div>
              <div
                class="actionBarItem"
                @click="batActionHuashu(1)"
              >
                刷新
              </div>
              <div
                class="actionBarItem"
                @click="batActionHuashu(2)"
              >
                置顶
              </div>
              <div
                class="actionBarItem"
                @click="batActionHuashu(4)"
              >
                删除
              </div>
            </div>
          </div>
        </div>
        <div
          class="huashuList"
          ref="huashuList"
          @scroll="huashuOnScroll"
        >
          <div
            v-if="tabIndex == 0"
            @mouseleave="huashuListMouseleave"
          >
            <div
              v-if="countTopHuashu && !isSeaching"
              class="topBar"
              @click="openTopHuashu"
            >
              <div class="topBarL">
                <img
                  src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826161724.png"
                />置顶话术 {{ countTopHuashu }}条
              </div>
              <img
                v-if="!huashuTopBarShow"
                class="topBarR"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101203.png"
              />
              <img
                v-else
                class="topBarR"
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240708100936.png"
              />
            </div>
            <div
              class="huashuListItemPP"
              :style="{
                'padding-top':
                  (countTopHuashu > 0 && tabIndex == 0) || isSeaching
                    ? '32px'
                    : 0,
                height:
                  (countTopHuashu > 0 && tabIndex == 0) || isSeaching
                    ? ' calc(100vh - 278px)'
                    : ' calc(100vh - 246px)',
              }"
            >
              <div
                class="huashuListItemP"
                v-for="(item, idx) in showHuashuList"
                :key="'showHuashuList' + item.id + idx"
                :style="{ 'background-color': getHuashuItemBgColor(item, idx) }"
              >
                <div
                  v-if="huashuBatState"
                  class="huashuListItemActionIcon"
                  @click="selectHuashu(item, idx)"
                >
                  <img
                    v-if="!item.select"
                    src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812181908.png"
                  />
                  <img
                    v-else
                    src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812180929.png"
                  />
                </div>
                <!-- <div
                class="huashuListItem"
                @mouseenter="huashuItemMouseIn($event, item, idx)"
                @mouseover="huashuItemHover($event, item, idx)"
                @mouseleave="huashuItemMouseleave"
                :key="'showHuashuList' + item.id + idx"
                :style="{ 'background-color': getHuashuItemBgColor(item, idx) }"
                @contextmenu.prevent="showMenu($event, item, idx)"
              > -->
                <!-- <div
                class="huashuListItem"
                :key="'showHuashuList' + item.id + idx"
                @contextmenu.prevent="showMenu($event, item, idx)"
              > -->
                <div
                  class="huashuListItem"
                  :key="'showHuashuList' + item.id + idx"
                >
                  <div
                    v-if="item.title"
                    class="huashuListItemTop"
                  >
                    <img
                      class="huashuListItemTopL"
                      src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"
                    />
                    <div class="huashuListItemTopM">
                      {{ item.title }}
                    </div>
                    <img
                      v-if="item.imglist && item.imglist.length"
                      class="huashuListItemTopR"
                      src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                      @click="go2ImageList(idx)"
                    />
                    <img
                      v-else-if="item.filelist && item.filelist.length"
                      class="huashuListItemTopR"
                      src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                      @click="go2ImageList(idx)"
                    />
                  </div>
                  <div
                    :ref="item.id"
                    class="huashuListItemDetailNoHide"
                    v-html="item.allText"
                  ></div>
                  <div v-if="item.title">
                    <!-- <div
                    :class="
                      item.showBtn && item.showBtn == 'shouqi'
                        ? 'huashuListItemDetailShowmore'
                        : 'huashuListItemDetail'
                    "
                    :style="{
                      '-webkit-line-clamp':
                        wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                    }"
                    :ref="'show' + item.id"
                    @click="textShowClick(idx)"
                    @dblclick="itemClick(idx, true)"
                    v-html="item.allText"
                  ></div> -->
                    <div
                      :class="
                        item.showBtn && item.showBtn == 'shouqi'
                          ? 'huashuListItemDetailShowmore'
                          : 'huashuListItemDetail'
                      "
                      :style="{
                        '-webkit-line-clamp':
                          wenanShowLineCount == -1
                            ? 'unset'
                            : wenanShowLineCount,
                      }"
                      :ref="'show' + item.id"
                      @mousedown="itemMouseDown"
                      @mousemove="itemMouseMove"
                      @mouseup="itemMouseUp($event, idx)"
                      v-html="item.allText"
                    ></div>
                  </div>
                  <div v-else>
                    <!-- <div
                    class="huashuListItemDetail huashuListItemDetailNoTitle"
                    :ref="'show' + item.id"
                    :style="{
                      'text-indent':
                        (item.imglist && item.imglist.length) ||
                        (item.filelist && item.filelist.length)
                          ? '26px'
                          : 0,
                      display:
                        item.showBtn && item.showBtn == 'shouqi'
                          ? 'block'
                          : '-webkit-box',
                      '-webkit-line-clamp':
                        wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                    }"
                    @click="textShowClick(idx)"
                    @dblclick="itemClick(idx, true)"
                    v-html="item.allText"
                  ></div> -->
                    <div
                      :class="
                        item.showBtn && item.showBtn == 'shouqi'
                          ? 'huashuListItemDetailShowmore huashuListItemDetailNoTitle'
                          : 'huashuListItemDetail huashuListItemDetailNoTitle'
                      "
                      :style="{
                        '-webkit-line-clamp':
                          wenanShowLineCount == -1
                            ? 'unset'
                            : wenanShowLineCount,
                      }"
                      :ref="'show' + item.id"
                      @mousedown="itemMouseDown"
                      @mousemove="itemMouseMove"
                      @mouseup="itemMouseUp($event, idx)"
                      v-html="item.allText"
                    ></div>
                  </div>
                  <div
                    v-if="!huashuBatState"
                    class="huashuPs"
                  >
                    <div class="actionBar">
                      <div
                        class="actionBarItem"
                        @click="copyHuashu(item)"
                      >
                        复制
                      </div>
                      <div
                        class="actionBarItem"
                        @click="editHuashu(item)"
                      >
                        编辑
                      </div>
                      <div
                        class="actionBarItem"
                        @click="moveHuashu2First(item)"
                      >
                        刷新
                      </div>
                      <div
                        class="actionBarItem"
                        @click="setHuashuTop(item)"
                      >
                        {{ item.isTop ? "取消置顶" : "置顶" }}
                      </div>
                      <div
                        class="actionBarItem"
                        @click="removeHuashu(item)"
                      >
                        删除
                      </div>
                    </div>
                    <!-- <div
                    v-if="item.showBtn == 'zhankai' && !hoverPreviewCheck"
                    class="actionBtn"
                    @click.stop="textShowClick(idx)"
                  >
                    <img
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812173851.png"
                    />
                    展开
                  </div>
                  <div
                    v-else-if="item.showBtn == 'shouqi' && !hoverPreviewCheck"
                    class="actionBtn"
                    @click.stop="textShowClick(idx)"
                  >
                    <img
                      :style="{ transform: 'rotate(180deg)' }"
                      src="https://imagessl.lingtuo.cn/A-1ed71af7_20250812173851.png"
                    />
                    收起
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabIndex == 1">
            <div
              class="huashuListItem"
              :style="{ border: 'none' }"
            >
              <div
                v-if="themeList.length && themeList[themeSelIdx].title"
                class="huashuListItemTop"
              >
                <!-- <img class="huashuListItemTopL" src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"> -->
                <!-- <div class="huashuListItemTopM huashuListItemTopMBig">{{themeList[themeSelIdx].title}}</div> -->
                <!--  <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click="go2ImageList(idx)"> -->
              </div>
              <!-- <div v-for="(wenan,idx) in wenanList" @contextmenu.prevent="showWenanMenu($event,wenan,idx)"> -->
              <div
                v-for="(wenan, idx) in wenanList"
                :key="'wenanListItem' + idx"
                class="huashuListItemDetailP"
              >
                <div
                  :ref="wenan.libraryId"
                  class="huashuListItemDetailNoHide"
                >
                  {{ wenan.text }}
                </div>
                <!-- <div v-if="item.title"> -->
                <div
                  :class="
                    wenan.showBtn && wenan.showBtn == 'shouqi'
                      ? 'huashuListItemDetailShowmore'
                      : 'huashuListItemDetail'
                  "
                  :style="{
                    '-webkit-line-clamp':
                      wenanShowLineCount == -1 ? 'unset' : wenanShowLineCount,
                  }"
                  :ref="'show' + wenan.libraryId"
                  @click="wenanItemClick(idx)"
                  @dblclick="wenanItemClick(idx, true)"
                >
                  {{ wenan.text }}
                </div>
                <div
                  v-if="wenan.showBtn == 'zhankai' && !hoverPreviewCheck"
                  class="actionBtn"
                  @click.stop="textShowClick(idx)"
                >
                  展开
                </div>
                <div
                  v-else-if="wenan.showBtn == 'shouqi' && !hoverPreviewCheck"
                  class="actionBtn"
                  @click.stop="textShowClick(idx)"
                >
                  收起
                </div>
                <!-- </div>
                                    <div v-else>
                                        <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id" :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'23px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box'}" @click="itemClick(idx)">
                                            <img v-if="item.imglist&&item.imglist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click.stop="go2ImageList(idx)">
                                            <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click.stop="go2ImageList(idx)">
                                            {{item.allText}}
                                        </div>
                                        <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                        <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                    </div> -->
              </div>
            </div>
          </div>
          <!-- <huashu-item-right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]" :menuData="menuData" @edit="editHuashu" @remove="removeHuashu" @hideMenu="hideMenu"></huashu-item-right-menu> -->
        </div>
      </div>
      <!-- </multipane> -->
    </div>
    <right-menu
      v-show="menuShow"
      ref="chat-item-right-menu"
      :menuY="menuPos[1]"
      :menuX="menuPos[0]"
      :cellList="menuCellList"
      @cellClick="rightMenuCellClick"
      @hideMenu="hideMenu"
    ></right-menu>
    <el-dialog
      title="选择分类"
      :visible.sync="showChooseHuashuTypeDialog"
    >
      <div class="chooseHuashuTypeList">
        <div
          v-for="(item, idx) in typeList"
          :class="
            chooseTypeSelIdx == idx
              ? 'typeListItemSel typeListItem'
              : 'typeListItem'
          "
          :key="'huashuChooseType' + idx"
          @click="chooseHuashuTypeClick(idx)"
        >
          <div>{{ item.labelName }}</div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="chooseHuashuTypeCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="chooseHuashuTypeConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="选择Mac芯片类型"
      :visible.sync="macDownloadDialogShow"
      width="420px"
    >
      <div class="macDownloadDialogContent">
        <div class="macDownloadTip">请选择您的Mac芯片类型下载对应版本</div>
        <div class="macDownloadBtns">
          <el-button
            type="primary"
            class="macDownloadBtn"
            @click="downloadAppleSilicon"
          >Apple Silicon（M1/M2/M3/M4）</el-button>
          <el-button
            class="macDownloadBtn"
            @click="downloadIntel"
          >Intel 芯片</el-button>
        </div>
      </div>
    </el-dialog>
    <face-panel
      v-if="facePanelShow"
      @facePanelClose="facePanelShow = false"
      @emojiClick="emojiClick"
    ></face-panel>

    <div
      v-if="huashuEditShow"
      class="huashuEditDialogCover"
    >
      <div class="huashuEditDialogCoverMain">
        <huashu-edit
          :isWeb="isWeb"
          :labelIdProps="labelId"
          :speechIdProps="speechId"
          @huashuEditClose="huashuEditClose"
          @huashuEditSuccess="huashuEditSuccess"
        ></huashu-edit>
      </div>
    </div>

    <div
      v-if="huashuImportShow"
      class="huashuEditDialogCover"
    >
      <div
        class="huashuEditDialogCoverMain"
        :style="{ height: '500px' }"
      >
        <huashu-import
          :isWeb="isWeb"
          :labelIdProps="labelId"
          :speechIdProps="speechId"
          :teamName="huashuTeamList[this.teamSelIdx].showName"
          @huashuImportClose="huashuImportClose"
        ></huashu-import>
      </div>
    </div>

    <ChangeHuashuTypeDialog
      v-if="typeList.length && changeHuashuTypeShow"
      :typeList="typeList"
      @save="changeHuashuTypeSave"
      @cancel="changeHuashuTypeCancel"
    ></ChangeHuashuTypeDialog>

    <!-- <el-dialog title="文案显示" custom-class="wenanLineCountDialog" :visible.sync="huashuLineCountDialogShow"
            @close='()=>{this.$store.commit("modifyHuashuLineCountDialogShow",false)}'>
            <div class="chooseHuashuTypeList">
                <el-radio-group v-model="tmpWenanShowLineCount" :style="{'display':'grid'}">
                    <el-radio :label="1" :style="{'margin-bottom':'10px'}">最多显示1行内容</el-radio>
                    <el-radio :label="3" :style="{'margin-bottom':'10px'}">最多显示3行内容</el-radio>
                    <el-radio :label="-1" :style="{'margin-bottom':'10px'}">全部显示</el-radio>
                </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="wenanLineCountCancel">取 消</el-button>
                <el-button type="primary" @click="wenanLineCountConfirm">确 定</el-button>
            </div>
        </el-dialog> -->
  </div>
</template>

<script>
import axios from "axios";
import dbService from "@/service/dbService";
import Vue from "vue";
import Fuse from "fuse.js";
import {
  Dialog,
  Button,
  Loading,
  Radio,
  RadioGroup,
  Switch,
  Popover,
} from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Popover);

import LoginDialog from "./LoginDialog";
import HuashuEdit from "./HuashuEdit";
import HuashuImport from "./HuashuImport";
import rightMenu from "@/components/RightMenu";
import facePanel from "@/components/FacePanel";
import ChangeHuashuTypeDialog from "@/components/ChangeHuashuTypeDialog";
import { Multipane, MultipaneResizer } from "vue-multipane";
// var mammoth = require("mammoth");

export default {
  name: "Home",
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      typeSelIdx: 0,
      teamSelIdx: 0,
      typeList: [],
      typeListLoadend: false,
      teamListLoadend: false,
      huashuList: [],
      showHuashuList: [],
      huashuListLoadend: false,
      huashuTeamList: [],
      typePageSize: 500,
      typePage: 1,
      huashuPageSize: 500,
      huashuPage: 1,
      speechId: 0, //团队id
      labelId: 0, //分类id
      huashuDetailId: 0, //话术文本id
      huashuTopBarShow: true,
      defaultThemeList: [], //默认文案包列表
      themeList: [], //文案包列表
      themeSelIdx: 0, //当前选中文案包索引
      themeId: 0, //当前选中文案包id
      themePage: 1,
      themePageSize: 500,
      themeCategoryList: [], //当前选中文案包分类列表
      themeCategorySelIdx: 0, //当前选中文案包分类索引
      themeCategoryPage: 1,
      themeCategoryPageSize: 20,
      themeCategoryLoading: false,
      themeCategoryLoadend: false,
      wenanLabelId: 0, //文案包分类id
      wenanPage: 1,
      wenanPageSize: 500,
      wenanloading: false,
      wenanList: [],
      wenanListLoadend: false,
      wenanId: 0, //文案id
      teamListShow: false,
      loading: false,
      hushuTypeLoading: false,
      hushuTeamLoading: false,
      audioList: [],
      eleList: [],
      faceIcon: "",
      userName: "",
      // loginDailogShow:false,
      menuPos: [],
      menuShow: false,
      menuData: {},
      tabIndex: 0,
      keywords: "",
      searchPage: 1,
      searchPageSize: 50,
      searchLoadend: false,
      searchLoading: false,
      isSeaching: false,
      typeListWidth: 288,
      menuCellList: [],
      countTopHuashu: 0,
      showChooseHuashuTypeDialog: false,
      chooseTypeSelIdx: 0,
      huashuItemHoverTimer: null,
      huashuItemHoverIdx: -1,
      isAISearch: false,
      aiSearchHeight: 48,
      aiSearchType: 1, //ai搜索类型：1.关键词搜搜 2.AI搜索
      facePanelShow: false,
      isHuashuItemHovering: false, //判断是否是悬停查看话术详情状态
      itemClickTimer: null,
      searchType: "", //类型：1增量同步，2七牛云同步，3服务端搜索，4更新同步参数无增量数据
      localHuashuListData: [],
      huashuEditShow: false,
      huashuImportShow: false,
      huashuBatState: 0, // 0 未选择 1 批量管理状态
      isWeb: true,
      joinNeedCheck: true,
      huashuValList: [],
      startTime: 0,
      startX: 0,
      startY: 0,
      isSelecting: false,
      currentHuashuTeamInfo: null,
      targetLabelId: null,
      changeHuashuTypeShow: false,
      macDownloadDialogShow: false,
      allSelect: false,
      titleList: [],
    };
  },
  computed: {
    isVip() {
      if (localStorage.getItem("edujia:group:web:kv")) {
        let result = this.$common.decrypt(
          localStorage.getItem("edujia:group:web:kv"),
          this.$store.state.lk,
        );
        return result;
      }
      return false;
    },
    selectHuashuCount() {
      return this.showHuashuList.filter((val) => {
        return val.select;
      }).length;
    },
    showAiSwitch() {
      return (
        this.isSeaching && this.huashuTeamList[this.teamSelIdx].roleId == 2
      );
    },
    contentHeight() {
      let height = this.pageHeight - 125 - 40;
      if (this.isSeaching && this.showAiSwitch) {
        height -= this.aiSearchHeight;
      }
      if (this.tabIndex == 1) {
        height += 32 + 40;
      }
      return height;
    },
    loginDailogShow() {
      return this.$store.state.loginDailogShow;
    },
    wenanShowLineCount() {
      console.log(
        "this.$store.state.settingInfo.wenanShowLineCount:",
        this.$store.state.settingInfo.wenanShowLineCount,
      );
      return this.$store.state.settingInfo.wenanShowLineCount
        ? this.$store.state.settingInfo.wenanShowLineCount
        : 3;
    },
    titleColor() {
      console.log(
        "this.$store.state.settingInfo.color:",
        this.$store.state.settingInfo.color,
      );
      return this.$store.state.settingInfo.color
        ? this.$store.state.settingInfo.color
        : "#4A90E2";
    },
    hoverPreviewCheck() {
      return (
        this.$store.state.settingInfo &&
        this.$store.state.settingInfo.hoverPreviewCheck
      );
    },
  },
  watch: {
    isAISearch() {
      if (this.isSeaching) {
        this.searchPage = 1;
        this.huashuList = [];
        this.searchLoadend = false;
        this.searchHuashu();
      }
    },
    aiSearchType() {
      if (this.isSeaching) {
        this.searchPage = 1;
        this.huashuList = [];
        this.searchLoadend = false;
        this.searchHuashu();
      }
    },
    wenanShowLineCount(val) {
      this.updateCellStyle();
    },
    keywords(val) {
      // if (!val) {
      //   this.isSeaching = false;
      // }
    },
    huashuList(val) {
      console.log("watch huashuList update:", val);
      if (this.huashuTopBarShow) {
        this.showHuashuList = this.huashuList;
      } else {
        this.showHuashuList = this.huashuList.filter((huashu) => {
          return !huashu.isTop;
        });
      }
      this.countTopHuashu = this.huashuList.filter((val) => {
        return val.isTop;
      }).length;
    },
  },
  components: {
    LoginDialog,
    rightMenu,
    Multipane,
    MultipaneResizer,
    facePanel,
    HuashuEdit,
    HuashuImport,
    ChangeHuashuTypeDialog,
  },
  methods: {
    searchAllText(allText) {
      const escapedKeyword = this.keywords;
      // 使用正则表达式匹配单词边界，避免部分匹配
      const pattern = new RegExp(escapedKeyword, "g");
      const replacement = '<span style="color:red;">$&</span>';
      let newText = allText.replace(pattern, replacement);
      console.log("newText:", newText);
      return newText;
    },
    changeHuashuTypeSave(targetLabelId) {
      this.targetLabelId = targetLabelId;
      this.batActionHuashu(3);
      this.changeHuashuTypeShow = false;
    },
    changeHuashuTypeCancel() {
      this.changeHuashuTypeShow = false;
    },
    itemMouseMove(event) {
      // 计算鼠标移动的距离
      const deltaX = Math.abs(event.clientX - this.startX);
      const deltaY = Math.abs(event.clientY - this.startY);
      // 如果移动距离超过阈值，则认为用户在尝试选择
      if (deltaX > 5 || deltaY > 5) {
        // 阈值可根据实际情况调整
        this.isSelecting = true;
      }
    },
    itemMouseUp(event, idx) {
      const endTime = new Date().getTime();
      const duration = endTime - this.startTime; // 计算鼠标按下到释放的时长

      // 如果时间很短且移动距离很小，则认为是点击
      if (duration < 300 && !this.isSelecting) {
        // 时间阈值也可调整
        // 执行你的点击事件处理逻辑
        // handleClickEvent();
        this.textShowClick(idx);
      } else {
        // 这里是选择操作，可以选择性地执行其他逻辑或什么都不做
        console.log("Text selected!");
      }
      // 重置状态
      this.isSelecting = false;
    },
    itemMouseDown(event) {
      this.isSelecting = false; // 重置状态
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startTime = new Date().getTime(); // 记录鼠标按下的时间
    },
    huashuSelectAll() {
      this.allSelect = !this.allSelect;
      this.showHuashuList = this.showHuashuList.map((val, idx) => {
        if (idx < 50) {
          if (this.allSelect) {
            val.select = true;
          } else {
            val.select = false;
          }
        }
        return val;
      });
    },
    replaceHuashuBianliang(text) {
      this.huashuValList.forEach((val) => {
        let tmp = val.value || "{" + val.fieldText + "}";
        text = this.replaceAll(text, "{$*" + val.id + "*$}", tmp);
      });
      const regex = /\{\$\*\d+\*\$\}/g;
      text = text.replace(regex, "[变量]");
      return text;
    },
    async huashuImportClose() {
      this.huashuImportShow = false;
      // window.location.reload();
      this.huashuListLoadend = false;
      // this.huashuPage = 1;
      // this.huashuList = [];
      // this.fetchHuashuList();

      this.typePage = 1;
      this.typeSelIdx = 0;
      this.typeList = [];
      this.huashuPage = 1;
      this.huashuList = [];
      this.typeListLoadend = false;
      await this.fetchHuashuTypeList();
    },
    huashuEditSuccess() {
      this.$message({
        message: "提交成功",
        type: "success",
      });
      // setTimeout(() => {
      this.huashuEditShow = false;
      // window.location.reload();
      this.huashuListLoadend = false;
      this.huashuPage = 1;
      this.huashuList = [];
      this.fetchHuashuList();
      // }, 1000);
    },
    //type: img、video、file
    getContentEditorFileItem(path, type, file) {
      const fileElement = document.createElement("div");
      fileElement.setAttribute("id", path);
      fileElement.setAttribute("contenteditable", "false");

      if (type == "img") {
        // fileElement.setAttribute('style', `background-image: url(${path})`);
        // fileElement.setAttribute('class', 'contentImgItem');
        const imgEle = document.createElement("img");
        imgEle.setAttribute("class", "contentImgItemImg");
        imgEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentImgItem");
        fileElement.appendChild(imgEle);
      } else if (type == "video") {
        const videoEle = document.createElement("video");
        videoEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentVideoItem");
        fileElement.appendChild(videoEle);
        const videoIconEle = document.createElement("img");
        videoIconEle.setAttribute(
          "src",
          "https://imagessl.edujia.com/A-1ed71af7_20231013134229.png",
        );
        videoIconEle.setAttribute("class", "contentVideoItemIcon");
        fileElement.appendChild(videoIconEle);
      } else if (type == "videoPreview") {
        fileElement.setAttribute("style", `background-image: url(${path})`);
        fileElement.setAttribute("class", "contentVideoPrviewItem");
      } else if (type == "file") {
        const fileoEle = document.createElement("div");
        fileElement.appendChild(fileoEle);
        const iconEle = document.createElement("img");
        iconEle.src = this.getFileIcon(file.file.name);
        iconEle.setAttribute("class", "contentFileItemIcon");
        fileElement.appendChild(iconEle);
        const nameEle = document.createElement("div");
        nameEle.innerHTML = file.file.name;
        nameEle.setAttribute("class", "contentFileItemLabel");
        fileElement.appendChild(nameEle);
        fileElement.setAttribute("class", "contentFileItem");
      }
      return fileElement;
    },
    huashuEditClose() {
      this.huashuEditShow = false;
    },
    confirmSwitchClick() {
      console.log("confirmSwitchClick...");
      if (
        document.getElementById("confirmSwitchClose").style["display"] !=
        "block"
      ) {
        document.getElementById("confirmSwitchClose").style["display"] =
          "block";
        document.getElementById("confirmSwitchOpen").style["display"] = "none";
        this.joinNeedCheck = false;
      } else {
        document.getElementById("confirmSwitchClose").style["display"] = "none";
        document.getElementById("confirmSwitchOpen").style["display"] = "block";
        this.joinNeedCheck = true;
      }
    },
    createTeam() {
      this.$confirm(
        '<div><input id="confirmInput" placeholder="请输入团队名称" /><div id="confirmSwitch">成员加入审核<img id="confirmSwitchOpen" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826142740.png" /><img id="confirmSwitchClose" src="https://imagessl.lingtuo.cn/A-1ed71af7_20250826150435.png" /></div></div>',
        "创建团队",
        {
          confirmButtonText: "保存",
          cancelButtonText: "取消",
          inputPattern: /^.+$/,
          inputErrorMessage: "团队名称不能为空",
          dangerouslyUseHTMLString: true,
        },
      ).then(async (res) => {
        if (res) {
          let teamName = document.getElementById("confirmInput").value;
          console.log("teamName:", teamName);

          let params = {
            name: teamName,
            isCheck: this.joinNeedCheck ? 1 : 0,
          };
          let resp = await this.$http.huashuTeamCreate(params);
          if (resp.code == 200) {
            document.getElementById("confirmInput").value = "";
            this.$message({
              message: "创建成功",
              type: "success",
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      });
      setTimeout(() => {
        document
          .getElementById("confirmSwitch")
          .addEventListener("click", this.confirmSwitchClick);
      }, 1);
    },
    go2review() {
      localStorage.setItem("typeList", JSON.stringify(this.typeList));
      this.$router.push("/huashuReview");
    },
    huashuBat() {
      this.huashuBatState = true;
    },
    huashuBatCompelete() {
      this.huashuTypeClick(this.typeSelIdx);
      this.huashuBatState = false;
    },
    selectHuashu(item, idx) {
      item.select = !item.select;
      this.showHuashuList.splice(idx, 1, item);
    },
    downloadFile(url, fileName) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    go2download() {
      if (this.isVip) {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.includes("mac")) {
          // macOS系统：弹出选择弹窗让用户选择芯片类型
          this.macDownloadDialogShow = true;
        } else {
          // Windows系统
          let ts = new Date().getTime();
          this.downloadFile(
            "	https://imagessl.lingtuo.cn/wminputWin1-2-4.zip?ts=" + ts,
            "微脉输入法",
          );
        }
      } else {
        this.$message({
          message: "请先购买vip然后再下载pc端",
          type: "warning",
        });
      }
    },
    downloadAppleSilicon() {
      this.macDownloadDialogShow = false;
      let ts = new Date().getTime();
      this.downloadFile(
        "https://imagessl.lingtuo.cn/wminputMac1-2-4.zip?ts=" + ts,
        "微脉输入法",
      );
    },
    downloadIntel() {
      this.macDownloadDialogShow = false;
      let ts = new Date().getTime();
      this.downloadFile(
        "	https://imagessl.lingtuo.cn/wminputMac1-2-4-intel.zip?ts=" + ts,
        "微脉输入法",
      );
    },
    getSyncParams(speechId) {
      let syncParams = null;
      let resultIdx = -1;
      let syncParamsList = [];
      if (localStorage.getItem("syncParamsList")) {
        syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
        resultIdx = syncParamsList.findIndex((val) => {
          return val.speechId == speechId;
        });
        if (resultIdx >= 0) {
          syncParams = syncParamsList[resultIdx].syncParams;
        }
      }
      return syncParams;
    },
    updateSyncParams(syncParams, speechId) {
      return new Promise((resolve, reject) => {
        let resultIdx = -1;
        let syncParamsList = [];
        if (localStorage.getItem("syncParamsList")) {
          syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
          resultIdx = syncParamsList.findIndex((val) => {
            return val.speechId == speechId;
          });
          if (resultIdx >= 0) {
            syncParams = syncParamsList[resultIdx].syncParams;
          }
        }
        if (resultIdx >= 0) {
          syncParamsList[resultIdx].syncParams = syncParams;
        } else {
          syncParamsList.push({
            syncParams: syncParams,
            speechId: speechId,
          });
        }
        localStorage.setItem("syncParamsList", JSON.stringify(syncParamsList));
        resolve();
      });
    },
    async huashuCheckIncrement() {
      return new Promise(async (resolve, reject) => {
        let syncParams = this.getSyncParams(this.speechId);
        let params = {
          speechId: this.speechId,
        };
        if (syncParams) {
          params.syncParams = syncParams;
        }
        console.log("huashuCheckIncrement params=", params);
        let resp = await this.$http.huashuCheckIncrement(params);
        if (resp.code == 200) {
          if (resp.data.object.syncParams) {
            await this.updateSyncParams(
              resp.data.object.syncParams,
              this.speechId,
            );
          }
          this.searchType = resp.data.object.type;
          //有增量更新
          if (this.searchType != 4) {
            if (this.searchType == 2) {
              //七牛云同步
              axios.get(resp.data.object.url).then(async (response) => {
                console.log("response:", response);
                if (response.data && response.data.length) {
                  this.localHuashuListData.push(...response.data);
                  await dbService.addData(
                    "huashuList",
                    response.data,
                    new Date().getTime(),
                    this.speechId,
                  );
                }
                await this.huashuCheckIncrement(resp.data.object.syncParams);
                resolve();
              });
            } else if (this.searchType == 1) {
              //增量添加
              await this.huashuCheckIncrementAdd(resp.data.object.syncParams);

              //增量删除
              await this.huashuCheckIncrementDel(resp.data.object.syncParams);
              resolve();
            }
          }
        }
      });
    },
    //增量添加
    huashuCheckIncrementAdd(syncParams) {
      return new Promise(async (resolve, reject) => {
        let zenParam = {
          speechId: this.speechId,
        };
        if (syncParams) {
          zenParam.syncParams = syncParams;
        }
        let zenResp = await this.$http.huashuCheckIncrementAdd(zenParam);
        if (zenResp.code == 200) {
          if (zenResp.data.syncParams) {
            await this.updateSyncParams(zenResp.data.syncParams, this.speechId);
          }
          if (zenResp.data.array.length) {
            await dbService.addData(
              "huashuList",
              zenResp.data.array,
              this.speechId,
            );
            this.localHuashuListData.push(...zenResp.data.array);
            if (zenResp.data.isNextData) {
              await this.huashuCheckIncrementAdd(zenResp.data.syncParams);
            }
          } else {
            console.log("增量增加拉取结束...");
          }
        }
        resolve();
      });
    },
    //增量删除
    huashuCheckIncrementDel(syncParams) {
      return new Promise(async (resolve, reject) => {
        let delParam = {
          speechId: this.speechId,
        };
        if (syncParams) {
          delParam.syncParams = syncParams;
        }
        let delResp = await this.$http.huashuCheckIncrementDel(delParam);
        if (delResp.code == 200) {
          if (delResp.data.syncParams) {
            await this.updateSyncParams(delResp.data.syncParams, this.speechId);
          }
          if (delResp.data.array.length) {
            // this.localHuashuListData.push(...response.data);
            this.localHuashuListData = this.localHuashuListData.filter(
              (item) => {
                return !delResp.data.array.some((removeitem) => {
                  return removeitem.id == item.id;
                });
              },
            );
            await dbService.delData("huashuList", delResp.data.array);
            if (delResp.data.isNextData) {
              await this.huashuCheckIncrementDel(delResp.data.syncParams);
            }
          } else {
            console.log("增量删除拉取结束...");
          }
        }
        resolve();
      });
    },
    getHuashuItemBgColor(item, idx) {
      let color = "#fff";
      if (item.isTop && !this.isSeaching) {
        color = "#eee";
      }

      if (this.huashuItemHoverIdx == idx) {
        if (color == "#fff") {
          color = "#eee";
        } else {
          color = "#fff";
        }
      }

      return color;
    },
    emojiClick(emoji) {
      navigator.clipboard.writeText(emoji.emoji).then(
        () => {
          this.$message({
            message: "文本已复制",
            type: "success",
          });
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.send("type-text", emoji.emoji);
        },
        function () {
          console.log("文件复制失败！");
        },
      );
    },
    faceBtnClick() {
      this.facePanelShow = !this.facePanelShow;
    },
    openTopHuashu() {
      this.huashuTopBarShow = !this.huashuTopBarShow;
      if (this.huashuTopBarShow) {
        this.showHuashuList = this.huashuList;
        localStorage.removeItem("huashuTopBarHide");
      } else {
        this.showHuashuList = this.huashuList.filter((huashu) => {
          return !huashu.isTop;
        });
        localStorage.setItem("huashuTopBarHide", 1);
      }
      this.updateCellStyle();
    },
    chooseHuashuTypeCancel() {
      this.showChooseHuashuTypeDialog = false;
    },
    async chooseHuashuTypeConfirm() {
      const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        speechId: this.speechId,
        labelId: this.typeList[this.typeSelIdx].labelId,
        id: this.menuData.id,
        targetLabelId: this.typeList[this.chooseTypeSelIdx].labelId,
      };
      console.log("huashuTypeSave params=", params);
      let resp = await this.$http.moveHuashuType(params);
      if (resp.code == 200) {
        let huashuIdx = this.huashuList.findIndex((huashu) => {
          return huashu.id == this.menuData.id;
        });
        this.huashuList.splice(huashuIdx, 1);
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }
      this.showChooseHuashuTypeDialog = false;
      loading.close();
    },
    //选择话术分类
    chooseHuashuTypeClick(idx) {
      this.chooseTypeSelIdx = idx;
    },
    convertFileData(text) {
      const regex = /【([^【】]+)】(?:\n\n((?:■[^【]+(?:\n[^【■]+)*)*))/g;
      let matches;
      const result = [];

      while ((matches = regex.exec(text)) !== null) {
        const category = matches[1].trim();
        const categoryText = matches[2].trim();

        // 解析分类中的标题和内容
        const categoryRegex = /■([^【\n]+)\n([^■]*)/g;
        let categoryMatches;
        const categoryData = [];

        while ((categoryMatches = categoryRegex.exec(categoryText)) !== null) {
          const title = categoryMatches[1].trim();
          const content = categoryMatches[2].trim().replace(/\n+/g, "\n");
          categoryData.push({
            title,
            content,
          });
        }

        // 添加分类到结果数组
        result.push({
          type: category,
          sub: categoryData,
        });
      }
      console.log("convertFileData result:", result);
      return result;
    },
    paneresizestop(e) {
      localStorage.setItem("typeListWidth", e.clientWidth);
    },
    async cancelSearch() {
      this.isSeaching = false;
      this.huashuPage = 1;
      this.huashuList = [];
      this.keywords = "";
      this.huashuListLoadend = false;
      this.fetchHuashuList();
    },
    async searchBtnClick() {
      this.isSeaching = true;
      this.searchPage = 1;
      this.huashuList = [];
      this.searchLoadend = false;
      this.huashuBatState = false;
      this.searchHuashu();
    },
    async localSearchHuashu() {
      return new Promise(async (resolve, reject) => {
        console.log("localSearchHuashu...");
        // let localHuashuList = await dbService.search(this.keywords,'huashuList')
        // this.localHuashuListData = await dbService.getAllData("huashuList")
        let localHuashuListData = this.localHuashuListData;
        console.log("localHuashuList:", localHuashuListData);
        let options = {
          keys: ["title", "speechText", "allText"], // 多个搜索键
          threshold: 0.6, // 阈值控制匹配的敏感度
          shouldSort: true, // 是否对结果进行排序
          location: 0, // 匹配的位置，0 表示开头匹配
          distance: 100, // 搜索的最大距离
          minMatchCharLength: 2, // 最小匹配字符长度
        };
        const fuse = new Fuse(localHuashuListData, options);
        let localHuashuList = fuse.search(this.keywords).map((val) => {
          return val.item;
        });
        console.log("localSearchHuashu result:", localHuashuList);
        if (!localHuashuList) {
          return;
        }
        localHuashuList = localHuashuList.map((val) => {
          val.eleList = this.generateEleList(val.speechText);
          val.imglist = val.eleList.filter((eleListItem) => {
            eleListItem.val = eleListItem.val.replace("http://", "https://");
            return eleListItem.type == "img" || eleListItem.type == "video";
          });
          val.filelist = val.eleList.filter((eleListItem) => {
            eleListItem.val = eleListItem.val.replace("http://", "https://");
            return eleListItem.type == "file" || eleListItem.type == "audio";
          });
          val.allText = this.getEleListAllText(val.eleList);
          return val;
        });
        this.huashuList.splice(this.huashuList.length, 0, ...localHuashuList);
        if (this.huashuTopBarShow) {
          this.showHuashuList = this.huashuList;
        } else {
          this.showHuashuList = this.huashuList.filter((huashu) => {
            return !huashu.isTop;
          });
        }
      });
    },
    async searchHuashu() {
      // //检查增量更新搜索
      // await this.huashuCheckIncrement();
      // if (
      //   this.searchType != 3 &&
      //   !(this.isAISearch && this.aiSearchType == 2)
      // ) {
      //   await this.localSearchHuashu();
      //   return;
      // }

      this.searchLoading = true;
      let params = {
        page: this.searchPage,
        pageSize: this.searchPageSize,
        speechId: this.speechId,
        keyword: this.keywords,
        isAIEnable: this.isAISearch && this.aiSearchType == 2 ? 1 : 0,
      };
      console.log("huashuSearch params:", params);
      let resp = await this.$http.huashuSearch(params);
      console.log("huashuSearch resp:", resp);
      if (resp.code == 200) {
        if (resp.data.array.length) {
          resp.data.array = resp.data.array.map((val) => {
            val.eleList = this.generateEleList(val.speechText);
            val.imglist = val.eleList.filter((eleListItem) => {
              eleListItem.val = eleListItem.val.replace("http://", "https://");
              return eleListItem.type == "img" || eleListItem.type == "video";
            });
            val.filelist = val.eleList.filter((eleListItem) => {
              eleListItem.val = eleListItem.val.replace("http://", "https://");
              return eleListItem.type == "file" || eleListItem.type == "audio";
            });
            val.allText = this.getEleListAllText(val.eleList);
            return val;
          });
          this.huashuList.splice(this.huashuList.length, 0, ...resp.data.array);
          if (this.huashuTopBarShow) {
            this.showHuashuList = this.huashuList;
          } else {
            this.showHuashuList = this.huashuList.filter((huashu) => {
              return !huashu.isTop;
            });
          }
        }
        if (resp.data.array.length < this.searchPageSize) {
          this.searchLoadend = true;
        } else {
          this.searchPage++;
        }
      }
      this.searchLoading = false;
      this.updateCellStyle();
    },
    //批量操作 actionType 操作类型：1刷新，2置顶，3移动，4删除
    async batActionHuashu(actionType) {
      let selectArray = this.showHuashuList.filter((val) => {
        return val.select;
      });

      if (!selectArray || !selectArray.length) {
        this.$message({
          message: "请选择话术",
          type: "warning",
        });
        return;
      }

      if (actionType == 4) {
        let result = await this.$confirm("确定删除？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).catch(() => {
          console.log("取消了");
        });
        if (!result) {
          return;
        }
      }

      let idArray = selectArray.map((val) => val.id);
      let params = {
        speechId: this.speechId,
        labelId: this.labelId,
        idArray: JSON.stringify(idArray),
        type: actionType,
      };
      if (actionType == 3) {
        params.targetLabelId = this.targetLabelId;
      }
      console.log("huashuBatchOperate params=", params);
      let resp = await this.$http.huashuBatchOperate(params);
      if (resp.code == 200) {
        this.huashuListLoadend = false;
        this.huashuPage = 1;
        this.huashuList = [];
        this.fetchHuashuList();
        this.targetLabelId = null;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }
    },
    rightMenuCellClick(idx) {
      if (
        this.huashuTeamList[this.teamSelIdx] &&
        this.huashuTeamList[this.teamSelIdx].roleId == 0
      ) {
        this.$message({
          message: "无权限",
          type: "warning",
        });
        return;
      }

      if (this.menuCellList[idx].action == "removeHuashu") {
        //删除话术
        this.removeHuashu();
      } else if (this.menuCellList[idx].action == "insertHuashu") {
        //新增话术
        this.addHuashu();
      } else if (this.menuCellList[idx].action == "editHuashu") {
        //编辑话术
        this.editHuashu();
      } else if (this.menuCellList[idx].action == "setHuashuTop") {
        //固定置顶话术
        this.setHuashuTop();
      } else if (this.menuCellList[idx].action == "setHuashuNoTop") {
        //取消置顶话术
        this.setHuashuNoTop();
      } else if (this.menuCellList[idx].action == "moveHuashu2First") {
        //刷到顶部
        this.moveHuashu2First();
      } else if (this.menuCellList[idx].action == "moveHuashuType") {
        //移动话术类型
        this.moveHuashuType();
      } else if (this.menuCellList[idx].action == "editHuashuType") {
        //编辑话术类型
        this.editHuashuType();
      } else if (this.menuCellList[idx].action == "delHuashuType") {
        //删除话术类型
        this.delHuashuType();
      } else if (this.menuCellList[idx].action == "refreshHuashuType") {
        //刷新话术类型
        this.refreshHuashuType();
      }
    },
    tabClick(idx) {
      this.isSeaching = false;
      this.keywords = "";
      this.tabIndex = idx;
      this.fetchData();
    },
    importHuashu() {
      let team = this.huashuTeamList[this.teamSelIdx];

      // if (!this.typeList.length) {
      //   this.$message({
      //     message: "请先添加分类",
      //     type: "warning",
      //   });
      //   return;
      // }

      if (team.roleId == 0) {
        this.$message({
          message: "无权限操作此话术",
          type: "warning",
        });
        return;
      }

      this.huashuImportShow = true;

      // this.$router.push({
      //     path: '/huashuImport',
      //     query: {
      //         speechId: this.speechId,
      //         labelId: this.labelId,
      //         teamName: this.huashuTeamList[this.teamSelIdx].showName
      //     }
      // })
    },
    addHuashuType() {
      this.$prompt("", "添加分类", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "分类名称不能为空",
      })
        .then(async ({ value }) => {
          let params = {
            speechId: this.speechId,
            labelName: value,
          };
          console.log("huashuTypeSave params=", params);
          let resp = await this.$http.huashuTypeSave(params);
          if (resp.code == 200) {
            console.log("huashuTypeSave resp:", resp);
            this.typeList.splice(this.typeList.length, 0, resp.data.object);
          } else {
            this.$message({
              message: resp.message,
              type: "warning",
            });
          }
        })
        .catch(() => {});
    },
    addHuashu() {
      let team = this.huashuTeamList[this.teamSelIdx];
      if (!this.typeList.length) {
        this.$message({
          message: "请先添加分类",
          type: "warning",
        });
        return;
      }

      if (team.roleId == 0) {
        this.$message({
          message: "无权限操作此话术",
          type: "warning",
        });
        return;
      }

      if (localStorage.getItem("editHuashuData")) {
        localStorage.removeItem("editHuashuData");
      }

      this.huashuEditShow = true;
      // this.$router.push({
      //     path: '/huashuEdit',
      //     query: {
      //         speechId: this.speechId,
      //         labelId: this.labelId
      //     }
      // })
      // if(window.require){
      //     const {ipcRenderer} = window.require('electron');
      //     ipcRenderer.send('openHuashuEdit', JSON.stringify({
      //         speechId: this.speechId,
      //         labelId: this.labelId,

      //     }));
      // }
    },
    async removeHuashu(item) {
      if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
        this.$confirm("确定删除？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let params = {
              speechId: this.speechId,
              labelId: this.isWeb ? item.labelId : this.menuData.labelId,
              id: this.isWeb ? item.id : this.menuData.id,
            };
            console.log("huashuRemove params=", params);
            let resp = await this.$http.huashuRemove(params);
            if (resp.code == 200) {
              console.log("huashuRemove resp:", resp);

              let huashuIdx = this.menuData.idx;
              if (this.isWeb) {
                huashuIdx = this.huashuList.findIndex((huashu) => {
                  return huashu.id == item.id;
                });
              }

              this.huashuList.splice(huashuIdx, 1);
              let tempList = this.huashuList.map((val, idx) => {
                val.idx = idx;
                return val;
              });
              this.huashuList = tempList;
            } else {
              this.$message({
                message: resp.message,
                type: "warning",
              });
            }
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "无权限操作此话术",
          type: "warning",
        });
      }
    },
    changeHuashuType() {
      if (this.huashuTeamList[this.teamSelIdx].roleId == 0) {
        this.$message({
          message: "无权限操作此话术",
          type: "warning",
        });
        return;
      }
      if (!this.typeList.length) {
        this.$message({
          message: "话术无分类",
          type: "warning",
        });
        return;
      }

      let selectArray = this.showHuashuList.filter((val) => {
        return val.select;
      });
      if (!selectArray.length) {
        this.$message({
          message: "请选择话术",
          type: "warning",
        });
        return;
      }

      this.changeHuashuTypeShow = true;
    },
    copyHuashu(item) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = item.allText;
      const text = tempDiv.innerText || tempDiv.textContent;
      navigator.clipboard.writeText(text).then(
        () => {
          this.$message({
            message: "话术已复制",
            type: "success",
          });
        },
        () => {
          this.$message({
            message: "复制失败",
            type: "error",
          });
        },
      );
    },
    editHuashu(item) {
      if (!item && this.menuData) {
        item = this.menuData;
      }
      if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
        if (window.require) {
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.send(
            "openHuashuEdit",
            JSON.stringify({
              speechId: this.speechId,
              labelId: this.isWeb ? item.labelId : this.menuData.labelId,
              editHuashuData: this.isWeb ? item : this.menuData,
            }),
          );
        } else {
          if (this.isWeb) {
            let editData = Object.assign({}, item, { speechId: this.speechId });
            localStorage.setItem("editHuashuData", JSON.stringify(editData));
            this.huashuEditShow = true;
          } else {
            let editData = Object.assign({}, this.menuData, {
              speechId: this.speechId,
            });
            localStorage.setItem("editHuashuData", JSON.stringify(editData));
            this.$router.push({
              path: "/huashuEdit",
              query: {
                speechId: this.speechId,
                // labelId: this.labelId,
                // editHuashuData: this.menuData
              },
            });
          }
        }
      } else {
        this.$message({
          message: "无权限操作此话术",
          type: "warning",
        });
      }
    },
    delHuashuType() {
      console.log("this.menuData:", this.menuData);
      this.$confirm("删除话术分类", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async ({ value }) => {
          let rightIdx = this.typeList.findIndex(
            (val) => val.labelId == this.menuData.labelId,
          );
          let type = this.typeList[rightIdx];
          let params = {
            speechId: this.speechId,
            labelId: type.labelId,
          };
          console.log("huashuTypeDel params=", params);
          let resp = await this.$http.huashuTypeDel(params);
          if (resp.code == 200) {
            console.log("huashuTypeDel resp:", resp);
            type.labelName = value;
            this.typeList.splice(rightIdx, 1);
          } else {
            this.$message({
              message: resp.message,
              type: "warning",
            });
          }
        })
        .catch(() => {});
    },
    editHuashuType() {
      console.log("this.menuData:", this.menuData);
      this.$prompt("", "修改分类", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "分类名称不能为空",
      })
        .then(async ({ value }) => {
          let rightIdx = this.typeList.findIndex(
            (val) => val.labelId == this.menuData.labelId,
          );
          let type = this.typeList[rightIdx];
          let params = {
            speechId: this.speechId,
            labelName: value,
            labelId: type.labelId,
          };
          console.log("huashuTypeSave params=", params);
          let resp = await this.$http.huashuTypeSave(params);
          if (resp.code == 200) {
            console.log("huashuTypeSave resp:", resp);
            type.labelName = value;
            this.typeList.splice(rightIdx, 1, type);
          } else {
            this.$message({
              message: resp.message,
              type: "warning",
            });
          }
        })
        .catch(() => {});
    },
    //话术刷到顶部
    async moveHuashu2First(item) {
      if (!item && this.menuData) {
        item = this.menuData;
      }
      let params = {
        speechId: this.speechId,
        labelId: this.isWeb ? item.labelId : this.menuData.labelId,
        id: this.isWeb ? item.id : this.menuData.id,
      };
      console.log("huashuRefreshTop params=", params);
      let resp = await this.$http.huashuRefreshTop(params);
      if (resp.code == 200) {
        let huashuIdx = this.huashuList.findIndex((huashu) => {
          if (this.isWeb) {
            return huashu.id == item.id;
          } else {
            return huashu.id == this.menuData.id;
          }
        });
        let huashuItem = this.isWeb ? item : this.huashuList[huashuIdx];
        if (!huashuItem.isTop) {
          let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
            return !huashu.isTop;
          });
          if (huashuNoIsTopIdx > -1) {
            this.huashuList.splice(huashuIdx, 1);
            this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem);
          }
        } else {
          this.huashuList.splice(huashuIdx, 1);
          this.huashuList.splice(0, 0, huashuItem);
        }
      }
    },
    //话术更新置顶
    setHuashuTop(item) {
      this.updateHuashuIsTop(1, item);
    },
    //话术取消置顶
    setHuashuNoTop(item) {
      this.updateHuashuIsTop(0, item);
    },
    //更新话术置顶状态
    async updateHuashuIsTop(isTop, item) {
      if (this.isWeb) {
        if (!item && this.menuData) {
          item = this.menuData;
        }
        isTop = !item.isTop;
      }
      let params = {
        speechId: this.speechId,
        labelId: this.isWeb ? item.labelId : this.menuData.labelId,
        id: this.isWeb ? item.id : this.menuData.id,
        isTop: isTop,
      };
      console.log("updateHuashuIsTop params=", params);
      let resp = await this.$http.updateHuashuIsTop(params);
      if (resp.code == 200) {
        let huashuIdx = this.huashuList.findIndex((huashu) => {
          if (this.isWeb) {
            return huashu.id == item.id;
          } else {
            return huashu.id == this.menuData.id;
          }
        });
        let huashuItem = this.isWeb ? item : this.huashuList[huashuIdx];
        huashuItem.isTop = isTop;
        this.huashuList.splice(huashuIdx, 1);
        if (isTop) {
          this.huashuList.splice(0, 0, huashuItem);
        } else {
          let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
            return !huashu.isTop;
          });
          this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem);
        }
      }
    },
    //移动话术类型
    moveHuashuType() {
      this.showChooseHuashuTypeDialog = true;
    },
    //刷新话术类型
    async refreshHuashuType(item) {
      let params = {
        speechId: this.speechId,
        labelId: item ? item.labelId : this.menuData.labelId,
      };
      console.log("huashuTypeRefreshTop params=", params);
      let resp = await this.$http.huashuTypeRefreshTop(params);
      if (resp.code == 200) {
        let huashuTypeIdx = this.typeList.findIndex((huashuType) => {
          if (item) {
            return huashuType.labelId == item.labelId;
          } else {
            return huashuType.labelId == this.menuData.labelId;
          }
        });
        let huashuTypeItem = item ? item : this.typeList[huashuTypeIdx];
        this.typeList.splice(huashuTypeIdx, 1);
        this.typeList.splice(0, 0, huashuTypeItem);
      }
    },
    huashuItemMouseIn(e, item, idx) {
      console.log("huashuItemMouseIn...");
      this.huashuItemHoverIdx = idx;

      if (!this.hoverPreviewCheck) {
        return;
      }

      if (this.huashuItemHoverTimer) {
        return;
      }

      this.hoverShowing = true;
      let hoverPos = {
        x: e.pageX,
        y: e.pageY,
      };
      if (this.isHuashuItemHovering) {
        if (window.require) {
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.send(
            "huashuItemHover",
            JSON.stringify({ pos: hoverPos, text: item.allText }),
          );
        }
        // return;
      } else {
        // clearTimeout(this.huashuItemHoverTimer)
        // this.huashuItemHoverTimer=null
        this.huashuItemHoverTimer = setTimeout(() => {
          this.isHuashuItemHovering = true;
          if (window.require) {
            const { ipcRenderer } = window.require("electron");
            ipcRenderer.send(
              "huashuItemHover",
              JSON.stringify({ pos: hoverPos, text: item.allText }),
            );
          }
        }, 1000);
      }
    },
    huashuItemHover(e, item, idx) {},
    huashuItemMouseleave() {
      this.huashuItemHoverIdx = -1;
      if (!this.hoverPreviewCheck) {
        return;
      }
      if (this.huashuItemHoverTimer) {
        clearTimeout(this.huashuItemHoverTimer);
        this.huashuItemHoverTimer = null;
      }
      if (window.require) {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("huashuItemMouseleave");
      }
    },
    huashuListMouseleave() {
      this.huashuItemHoverIdx = -1;
      if (!this.hoverPreviewCheck) {
        return;
      }
      if (this.huashuItemHoverTimer) {
        clearTimeout(this.huashuItemHoverTimer);
        this.huashuItemHoverTimer = null;
      }
      setTimeout(() => {
        this.isHuashuItemHovering = false;
        if (window.require) {
          const { ipcRenderer } = window.require("electron");
          ipcRenderer.send("huashuItemMouseleave");
        }
      }, 100);
    },
    hideMenu() {
      this.menuShow = false;
    },
    showMenu(e, item, idx) {
      console.log("showMenu e:", e);
      console.log("showMenu item:", item);
      // this.menuPos=[e.x,e.y-this.$refs.huashuList.scrollTop];
      this.menuPos = [e.x, e.y];
      this.menuData = item;
      this.menuData.idx = idx;
      if (!this.isSeaching) {
        this.menuCellList = [
          {
            label: "编辑",
            action: "editHuashu",
          },
          {
            label: "新增",
            action: "insertHuashu",
          },
          {
            label: "刷到顶部",
            action: "moveHuashu2First",
          },
          {
            label: "移动",
            action: "moveHuashuType",
          },
          {
            label: "删除",
            action: "removeHuashu",
          },
        ];
        if (!this.menuData.isTop) {
          this.menuCellList.splice(2, 0, {
            label: "固定置顶",
            action: "setHuashuTop",
          });
        } else {
          this.menuCellList.splice(2, 0, {
            label: "取消置顶",
            action: "setHuashuNoTop",
          });
        }
      } else {
        this.menuCellList = [
          {
            label: "编辑",
            action: "editHuashu",
          },
          {
            label: "删除",
            action: "removeHuashu",
          },
        ];
      }
      this.menuShow = true;
    },
    showTypeMenu(e, item, idx) {
      console.log("showTypeMenu e:", e);
      console.log("showTypeMenu wenan:", item);
      this.menuPos = [e.x, e.y];
      this.menuData = item;
      this.menuData.idx = idx;
      this.menuCellList = [
        {
          label: "修改",
          action: "editHuashuType",
        },
        {
          label: "刷新",
          action: "refreshHuashuType",
        },
        {
          label: "删除",
          action: "delHuashuType",
        },
      ];
      this.menuShow = true;
    },
    loginDailogClick() {
      this.$store.commit(
        "modifyLoginDailogShow",
        !this.$store.state.loginDailogShow,
      );
    },
    textShowClick(idx) {
      //关闭悬浮窗
      this.huashuItemMouseleave();

      if (this.tabIndex == 0) {
        this.showHuashuList[idx].showBtn =
          this.showHuashuList[idx].showBtn == "zhankai" ? "shouqi" : "zhankai";
      } else if (this.tabIndex == 1) {
        this.wenanList[idx].showBtn =
          this.wenanList[idx].showBtn == "zhankai" ? "shouqi" : "zhankai";
      }
    },
    teamOnScroll(e) {
      if (this.hushuTeamLoading) {
        return;
      }

      let scrollHeight = e.target.scrollHeight;
      let clientHeight = e.target.clientHeight;
      let scrollTop = e.target.scrollTop;
      if (
        scrollHeight > clientHeight &&
        scrollTop >= scrollHeight - clientHeight - 60
      ) {
        if (!this.teamListLoadend) {
          this.fetchHuashuTeamList();
        }
      }
    },
    typeOnScroll(e) {
      if (
        (this.tabIndex == 0 && this.hushuTypeLoading) ||
        (this.tabIndex == 1 && this.themeCategoryLoading)
      ) {
        return;
      }

      let scrollHeight = e.target.scrollHeight;
      let clientHeight = e.target.clientHeight;
      let scrollTop = e.target.scrollTop;
      if (
        scrollHeight > clientHeight &&
        scrollTop >= scrollHeight - clientHeight - 60
      ) {
        if (this.tabIndex == 0 && !this.typeListLoadend) {
          this.fetchHuashuTypeList();
        } else if (this.tabIndex == 1 && !this.themeCategoryLoadend) {
          this.fetchWenanPackageCategoryList();
        }
      }
    },
    huashuOnScroll(e) {
      if (
        (this.tabIndex == 0 && (this.loading || this.searchLoading)) ||
        (this.tabIndex == 1 && this.wenanloading)
      ) {
        return;
      }

      let scrollHeight = e.target.scrollHeight;
      let clientHeight = e.target.clientHeight;
      let scrollTop = e.target.scrollTop;
      if (
        scrollHeight > clientHeight &&
        scrollTop >= scrollHeight - clientHeight - 5
      ) {
        if (this.tabIndex == 0 && !this.isSeaching && !this.huashuListLoadend) {
          this.fetchHuashuList();
        } else if (
          this.tabIndex == 0 &&
          this.isSeaching &&
          !this.searchLoadend
        ) {
          this.searchHuashu();
        } else if (this.tabIndex == 1 && !this.wenanListLoadend) {
          this.fetchWenanList();
        }
      }
    },
    hideTeamList() {
      this.teamListShow = false;
    },
    async teamItemClick(idx) {
      // this.isSeaching = false;
      this.searchPage = 1;
      this.searchLoadend = false;
      // this.keywords = "";
      this.teamSelIdx = idx;
      this.speechId = this.huashuTeamList[idx].speechId;
      localStorage.setItem("lastSelSpeechId", this.speechId);
      this.typePage = 1;
      this.typeSelIdx = 0;
      this.typeList = [];
      this.huashuPage = 1;
      this.huashuList = [];
      this.typeListLoadend = false;
      this.huashuListLoadend = false;
      await this.fetchHuashuTeamDetail();
      await this.fetchHuashuTypeList();
      this.teamListShow = false;
    },
    async themeItemClick(idx) {
      //切换文案包检查
      let params = {
        themeId: this.themeList[idx].themeId,
      };
      console.log("checkChangeWenanPackage params=", params);
      let resp = await this.$http.checkChangeWenanPackage(params);
      if (resp.code == 200) {
        this.themeSelIdx = idx;
        this.themeId = this.themeList[idx].themeId;
        localStorage.setItem("lastSelThemeId", this.themeId);
        this.themeCategoryPage = 1;
        this.themeCategorySelIdx = 0;
        this.themeCategoryList = [];
        this.themeCategoryLoadend = false;
        this.wenanPage = 1;
        this.wenanList = [];
        this.wenanListLoadend = false;
        this.fetchWenanPackageCategoryList();
        this.teamListShow = false;
      } else if (resp.code == 0) {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      } else if (resp.code == 8) {
        this.$msgbox({
          message: resp.message,
          type: "info",
        });
      }
    },
    changeTeam() {
      this.teamListShow = true;
    },
    go2ImageList(idx) {
      console.log("go2ImageList....");
      //关闭悬浮窗
      this.huashuItemMouseleave();

      let item = this.huashuList[idx];
      localStorage.setItem("huashuData", JSON.stringify(item));
      this.$router.push({
        path: "/imageList",
        query: {
          id: item.id,
        },
      });
    },
    huashuTypeClick(idx) {
      this.typeSelIdx = idx;
      this.labelId = this.typeList[idx].labelId;
      this.huashuListLoadend = false;
      this.huashuPage = 1;
      this.huashuList = [];
      this.fetchHuashuList();
    },
    wenanCategoryClick(idx) {
      this.themeCategorySelIdx = idx;
      this.wenanLabelId = this.themeCategoryList[idx].labelId;
      this.wenanListLoadend = false;
      this.wenanPage = 1;
      this.wenanList = [];
      this.fetchWenanList();
    },
    // 图片元素转base64
    getBase64Image(img) {
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0, img.width, img.height);
      let dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
    // 图片元素转base64
    getBase64(img) {
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0, img.width, img.height);
      let dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
    // base64图片转为blob
    getBlobImage(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 复制图片
    async copyImage(imageUrl) {
      return new Promise(async (resolve, reject) => {
        // let dataurl = this.getBase64Image(dom);
        // let blob = this.getBlobImage(dataurl);
        // const blob = await fetch(imageUrl).then(r => r.blob());

        fetch(imageUrl)
          .then((response) => {
            if (response.ok) {
              return response.blob();
            }
          })
          .then((blob) => {
            return new Promise((resolve, reject) => {
              let img = document.createElement("img");
              img.onload = () => {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0, img.width, img.height);
                canvas.toBlob(resolve, "image/png");
              };
              img.onerror = reject;
              img.src = URL.createObjectURL(blob);
            });
          })
          .then((pngBlob) => {
            let data = [new window.ClipboardItem({ [pngBlob.type]: pngBlob })];
            navigator.clipboard.write(data);
            resolve();
          })
          .then(() => {
            console.log("Image copied to clipboard successfully");
          })
          .catch((error) => {
            console.error("Error:", error);
          });

        // navigator.clipboard.write([
        // new window.ClipboardItem({
        //     [blob.type]: blob
        // })
        // ]).then(()=>{
        //     console.log("图片复制成功");
        //     resolve();
        // }, (err)=> {
        //     console.log('图片复制失败！ err:',err);
        //     resolve();
        // });
      });
    },
    itemClick(idx, isDbl = false) {
      //隐藏提示窗
      this.huashuItemMouseleave();
      return;
      let item = this.showHuashuList[idx];
      let text = item.allText;
      if (item.isCarryTitle) {
        text = item.title + "\n" + text;
      } else if (!text.length) {
        this.$message({
          message: "话术无内容",
          type: "warning",
        });
        return;
      }

      if (this.itemClickTimer) {
        clearTimeout(this.itemClickTimer);
        this.itemClickTimer = null;
      }
      this.itemClickTimer = setTimeout(async () => {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "文本已复制",
              type: "success",
            });
            console.log("item.text==", item.allText);
            const { ipcRenderer } = window.require("electron");
            // this.autoPartSend(item);
            // let tmpEleIdx = 0;
            // let autoTimer = setInterval(async ()=>{
            //     if(tmpEleIdx>=item.eleList.length){
            //         clearInterval(autoTimer)
            //         autoTimer=null;
            //         return;
            //     }
            //     if(item.eleList[tmpEleIdx].type=='text'){
            //         ipcRenderer.send('type-text', item.eleList[tmpEleIdx].val,isDbl);
            //     }else{
            //         await this.copyImage(item.eleList[tmpEleIdx].val);
            //         ipcRenderer.send('type-img');
            //     }

            //     tmpEleIdx++;
            // },1000)
            ipcRenderer.send("type-text", item.allText, isDbl);
          },
          function () {
            console.log("文件复制失败！");
          },
        );
      }, 300);
    },
    wenanItemClick(idx, isDbl = false) {
      if (this.itemClickTimer) {
        clearTimeout(this.itemClickTimer);
        this.itemClickTimer = null;
      }
      this.itemClickTimer = setTimeout(() => {
        let item = this.wenanList[idx];
        navigator.clipboard.writeText(item.text).then(
          () => {
            // if(this.tools.isElectron){
            this.$message({
              message: "文本已复制",
              type: "success",
            });
            console.log("item.text==", item.text);
            const { ipcRenderer } = window.require("electron");
            ipcRenderer.send("type-text", item.text, isDbl);
            // }
          },
          function () {
            console.log("文件复制失败！");
          },
        );
      }, 300);
    },
    async fetchData() {
      if (this.tabIndex == 0) {
        await this.fetchHuashuTeamList();
      } else {
        await this.fetchDefaultWenanPackageList();
        this.fetchWenanPackageList();
      }
    },
    //查询话术变量列表
    fetchHuashuValList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          speechId: this.speechId,
        };
        console.log("fetchHuashuValList params=", params);
        let resp = await this.$http.fetchHuashuValList(params);
        if (resp.code == 200) {
          this.huashuValList = resp.data.array;
          localStorage.setItem(
            "huashuValList",
            JSON.stringify(this.huashuValList),
          );
        }
        resolve();
      });
    },
    //查询默认文案包列表
    async fetchDefaultWenanPackageList() {
      return new Promise(async (resolve, reject) => {
        let params = {};
        console.log("wenanPackageList params=", params);
        let resp = await this.$http.defaultWenanPackageList(params);
        if (resp.code == 200) {
          this.defaultThemeList = [resp.data.object];
        }
        resolve();
      });
    },
    //查询文案包列表
    async fetchWenanPackageList() {
      let params = {
        page: this.themePage,
        pageSize: this.themePageSize,
        type: 1,
      };
      console.log("wenanPackageList params=", params);
      let resp = await this.$http.wenanPackageList(params);
      console.log("wenanPackageList resp:", resp);
      if (resp.code === 200) {
        if (this.themePage == 1 && resp.data.array && !resp.data.array.length) {
          // this.themeList.splice(this.themeList.length,0,resp.data.array)
          this.themeList = this.defaultThemeList;
        } else if (resp.data.array && resp.data.array.length) {
          this.themeList = resp.data.array;
        }

        if (localStorage.getItem("lastSelThemeId")) {
          this.themeId = localStorage.getItem("lastSelThemeId");
          this.themeList.forEach((theme, idx) => {
            if (this.themeId == theme.themeId) {
              this.themeSelIdx = idx;
            }
          });
        } else {
          this.themeId = this.themeList[0].themeId;
        }
        // else if(!this.themeList.length&&resp.data.array.length){
        //     this.themeId=this.themeList[0].themeId;
        // }
        // this.themeList=resp.data.array;
        if (this.themeList && this.themeList.length) {
          this.fetchWenanPackageCategoryList();
        }
        // else{
        //     this.$msgbox({
        //         message: '暂无文案包，请到微脉输入法App文案广场添加',
        //         type: 'info'
        //     }).then(() => {
        //         this.tabClick(0)
        //     });
        // }
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }
    },
    //查询文案包分类列表
    async fetchWenanPackageCategoryList() {
      this.themeCategoryLoading = true;
      let params = {
        page: this.themeCategoryPage,
        pageSize: this.themeCategoryPageSize,
        themeId: this.themeId,
      };
      console.log("wenanCategoryList params=", params);
      let resp = await this.$http.wenanCategoryList(params);
      console.log("wenanCategoryList resp:", resp);
      if (resp.code === 200) {
        if (resp.data.array.length < this.themeCategoryPageSize) {
          this.themeCategoryLoadend = true;
        }
        if (resp.data.array.length) {
          this.themeCategoryList.splice(
            this.themeCategoryList.length,
            0,
            ...resp.data.array,
          );
        }
        if (this.themeCategoryList.length && this.themeCategoryPage == 1) {
          this.wenanLabelId = this.themeCategoryList[0].labelId;
          this.fetchWenanList();
        }
        this.themeCategoryPage++;
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }
      this.themeCategoryLoading = false;
    },
    //查询文案列表
    async fetchWenanList() {
      this.wenanloading = true;
      let params = {
        page: this.wenanPage,
        pageSize: this.wenanPageSize,
        themeId: this.themeId,
        labelId: this.wenanLabelId,
      };
      console.log("wenanList params=", params);
      let resp = await this.$http.wenanList(params);
      console.log("wenanList resp:", resp);
      if (resp.code === 200) {
        if (resp.data.array.length < this.wenanPageSize) {
          this.wenanListLoadend = true;
        }
        if (resp.data.array.length) {
          // resp.data.array=resp.data.array.map((val)=>{
          //     val.eleList=this.generateEleList(val.speechText);
          //     val.imglist=val.eleList.filter((eleListItem)=>{
          //         eleListItem.val=eleListItem.val.replace("http://","https://")
          //          return eleListItem.type=='img'||eleListItem.type=='video'
          //     })
          //     val.filelist=val.eleList.filter((eleListItem)=>{
          //         eleListItem.val=eleListItem.val.replace("http://","https://")
          //          return eleListItem.type=='file'||eleListItem.type=='audio'
          //     })
          //     val.allText=this.getEleListAllText(val.eleList);
          //     return val;
          // })
          this.wenanList.splice(this.wenanList.length, 0, ...resp.data.array);
        }
        if (this.wenanList.length && this.wenanPage == 1) {
          this.wenanId = this.wenanList[0].libraryId;
        }
        this.wenanPage++;
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }
      this.updateCellStyle();
      this.wenanloading = false;
    },
    async fetchHuashuTeamList() {
      return new Promise(async (resolve, reject) => {
        let params = {};
        let resp = await this.$http.qryHuashuTeamList(params);
        if (resp.code === 200) {
          if (!resp.data.array.length) {
            this.$message({
              message: "未检测到话术团队，请在app端加入团队再使用",
              type: "error",
            });
            return;
          }
          if (localStorage.getItem("lastSelSpeechId")) {
            this.speechId = localStorage.getItem("lastSelSpeechId");
            resp.data.array.forEach((team, idx) => {
              if (this.speechId == team.speechId) {
                this.teamSelIdx = idx;
              }
            });
          } else if (!this.huashuTeamList.length && resp.data.array.length) {
            this.speechId = resp.data.array[0].speechId;
            localStorage.setItem("lastSelSpeechId", this.speechId);
          }

          this.huashuTeamList = resp.data.array;
          if (resp.data.array && resp.data.array.length) {
            await this.fetchHuashuTeamDetail();
            await this.fetchHuashuValList();
            await this.fetchHuashuTypeList();
          }
        } else {
          this.$message({
            message: resp.message,
            type: "warning",
          });
        }
        resolve();
      });
    },
    async fetchHuashuTeamDetail() {
      return new Promise(async (resolve, reject) => {
        this.hushuTypeLoading = true;
        let params = {
          speechId: this.speechId,
        };
        console.log("fetchHuashuTeamDetail params=", params);
        let resp = await this.$http.fetchHuashuTeamDetail(params);
        console.log("fetchHuashuTeamDetail resp:", resp);
        if (resp.code === 200) {
          this.currentHuashuTeamInfo = resp.data.object;
        } else {
          this.$message({
            message: resp.message,
            type: "warning",
          });
        }
        resolve();
      });
    },
    async fetchHuashuTypeList() {
      return new Promise(async (resolve, reject) => {
        this.hushuTypeLoading = true;
        let params = {
          page: this.typePage,
          pageSize: this.typePageSize,
          speechId: this.speechId,
        };
        console.log("qryHuashuTypeList params=", params);
        let resp = await this.$http.qryHuashuTypeList(params);
        console.log("qryHuashuTypeList resp:", resp);
        if (resp.code === 200) {
          //非话术创建者根据hideLabelIds隐藏分类
          if (
            this.currentHuashuTeamInfo &&
            this.currentHuashuTeamInfo.hideLabelIds &&
            this.currentHuashuTeamInfo.roleId != 2
          ) {
            let hideLabelIds = JSON.parse(
              this.currentHuashuTeamInfo.hideLabelIds,
            );
            hideLabelIds.forEach((hideTypeItem) => {
              resp.data.array.forEach((typeIteam) => {
                if (typeIteam.labelId == hideTypeItem) {
                  typeIteam.hide = true;
                }
              });
            });
          }
          resp.data.array = resp.data.array.filter((typeIteam) => {
            return !typeIteam.hide;
          });
          if (resp.data.array.length < this.typePageSize) {
            this.typeListLoadend = true;
          }
          if (resp.data.array.length) {
            this.typeList.splice(this.typeList.length, 0, ...resp.data.array);
          }
          if (this.typeList.length && this.typePage == 1) {
            this.labelId = this.typeList[0].labelId;
            if (this.isSeaching) {
              this.searchHuashu();
            } else {
              await this.fetchHuashuList();
            }
          }
          this.typePage++;
        } else {
          this.$message({
            message: resp.message,
            type: "warning",
          });
        }
        this.hushuTypeLoading = false;
        resolve();
      });
    },
    async fetchHuashuList() {
      return new Promise(async (resolve, reject) => {
        this.loading = true;
        let params = {
          page: this.huashuPage,
          pageSize: this.huashuPageSize,
          speechId: this.speechId,
          labelId: this.labelId,
        };
        console.log("qryHuashuList params=", params);
        let resp = await this.$http.qryHuashuList(params);
        console.log("qryHuashuList resp:", resp);
        if (resp.code === 200) {
          if (resp.data.array.length < this.huashuPageSize) {
            this.huashuListLoadend = true;
          }
          //获取返回值中所有的文件url
          let fileUrlList = [];
          resp.data.array.forEach((val) => {
            let urls = this.getAllFileUrl(val.speechText);
            fileUrlList.push(...urls);
          });
          if (fileUrlList.length) {
            console.log("fileUrlList:", fileUrlList);
            let tmpTitleList = await this.qryHuashuListTitle(fileUrlList);
            console.log("tmpTitleList:", tmpTitleList);
            this.titleList.push(...tmpTitleList);
          }

          if (resp.data.array.length) {
            resp.data.array = resp.data.array.map((val) => {
              val.eleList = this.generateEleList(val.speechText);
              val.imglist = val.eleList.filter((eleListItem) => {
                eleListItem.val = eleListItem.val.replace(
                  "http://",
                  "https://",
                );
                return eleListItem.type == "img" || eleListItem.type == "video";
              });
              val.filelist = val.eleList.filter((eleListItem) => {
                eleListItem.val = eleListItem.val.replace(
                  "http://",
                  "https://",
                );
                return (
                  eleListItem.type == "file" || eleListItem.type == "audio"
                );
              });
              let allText = this.getEleListAllText(val.eleList);
              val.allText = this.convertColorTags(allText);
              //替换话术变量
              val.allText = this.replaceHuashuBianliang(val.allText);
              return val;
            });
            this.huashuList.splice(
              this.huashuList.length,
              0,
              ...resp.data.array,
            );
            this.countTopHuashu = this.huashuList.filter((val) => {
              return val.isTop;
            }).length;
            if (this.huashuTopBarShow) {
              this.showHuashuList = this.huashuList;
            } else {
              this.showHuashuList = this.huashuList.filter((huashu) => {
                return !huashu.isTop;
              });
            }
          }
          if (this.huashuList.length && this.huashuPage == 1) {
            this.huashuDetailId = this.huashuList[0].id;
          }
          this.huashuPage++;
        } else {
          this.$message({
            message: resp.message,
            type: "warning",
          });
        }
        this.updateCellStyle();
        this.loading = false;
        resolve();
      });
    },
    updateCellStyle() {
      setTimeout(() => {
        let list = [];
        if (this.tabIndex == 0) {
          list = JSON.parse(JSON.stringify(this.showHuashuList));
        } else {
          list = JSON.parse(JSON.stringify(this.wenanList));
        }
        list.forEach((item) => {
          let id = this.tabIndex == 0 ? item.id : item.libraryId;
          if (this.$refs[id]) {
            let ele = this.$refs[id][0];
            let showEle = this.$refs["show" + id][0];
            let shouqiHeight = this.wenanShowLineCount * 20 - 1;
            if (
              ele.clientHeight > shouqiHeight &&
              ele.clientHeight > showEle.clientHeight
            ) {
              item.showBtn = "zhankai";
            } else {
              item.showBtn = "";
            }
            // console.log("ele:",ele);
          }
        });
        if (this.tabIndex == 0) {
          this.showHuashuList = list;
        } else {
          this.wenanList = list;
        }
      }, 1);
    },
    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },
    convertColorTags(html) {
      // 使用正则全局替换所有匹配的标签
      return html.replace(
        /<标记颜色开始(#(?:[\da-fA-F]{3}){1,2})>([\s\S]*?)<\/标记颜色结束>/gi,
        (match, colorCode, content) => {
          return `<span style="color: ${colorCode}">${content}</span>`;
        },
      );
    },
    getAllFileUrl(speechText) {
      // 定义常见文件扩展名的正则表达式
      const fileExtensions = [
        // 文档
        "pdf",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "pptx",
        "ppt",
        "txt",
        "rtf",
        "odt",
        // 压缩文件
        "zip",
        "rar",
        "7z",
        "tar",
        "gz",
        "bz2",
        // 音频
        "mp3",
        "wav",
        "ogg",
        "flac",
        "aac",
        "m4a",
      ];

      // 创建正则表达式模式
      const extensionPattern = fileExtensions.join("|");
      const urlRegex = new RegExp(
        `(https?:\\/\\/|www\\.|\\/)[^\\s]*\\.(${extensionPattern})(?:[?#].*)?`,
        "gi",
      );

      // 匹配所有文件URL
      const matches = speechText.match(urlRegex) || [];

      // 返回去重后的结果
      return [...new Set(matches)];
    },
    generateEleList(speechText) {
      let eleList = [];
      let _this = this;
      let text = speechText;
      text = this.replaceAll(text, "<分段>\n", "");
      text = this.replaceAll(text, "<分段>", "");
      text = this.replaceAll(text, "\n<连行开始>", "");
      text = this.replaceAll(text, "</连行结束>\n", "");
      text = this.replaceAll(text, "<连行开始>", "");
      text = this.replaceAll(text, "</连行结束>", "");
      // text = this.replaceAll(text, "\n", "\n");

      const urlRegex =
        /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
      const urls = [];
      let match;
      let lastPart = text;
      let newText = "";
      while ((match = urlRegex.exec(text)) !== null) {
        let url = match[0];
        const fileExtension = this.getFileExtension(url);

        // 只添加具有正确文件后缀的URL
        if (
          fileExtension === "png" ||
          fileExtension === "jpg" ||
          fileExtension === "jpeg" ||
          fileExtension === "pdf" ||
          fileExtension === "doc" ||
          fileExtension === "docx" ||
          fileExtension === "dotm" ||
          fileExtension === "dotx" ||
          fileExtension === "dotm" ||
          fileExtension === "txt" ||
          fileExtension === "xlsx" ||
          fileExtension === "xls" ||
          fileExtension === "mp4" ||
          fileExtension === "mov" ||
          fileExtension === "mp3" ||
          fileExtension === "m4a" ||
          fileExtension === "aac" ||
          fileExtension === "caf" ||
          fileExtension === "ppt" ||
          fileExtension === "pptx"
        ) {
          let tmp = lastPart.split(url);
          // console.log("tmp==",tmp[0]);
          eleList.push({
            type: "text",
            val: tmp[0],
          });
          if (
            fileExtension === "jpg" ||
            fileExtension === "png" ||
            fileExtension === "jpeg"
          ) {
            let fileElement = this.getContentEditorFileItem(url, "img");
            newText += tmp[0] + fileElement.outerHTML;
            lastPart = tmp[1];
            // eleList.push({
            //   type: "img",
            //   val: url,
            // });
          } else if (fileExtension === "mp4") {
            eleList.push({
              type: "video",
              val: url,
            });
          } else if (fileExtension === "mp3" || fileExtension === "m4a") {
            // let eleIdx = eleList.length;
            let tmpUrl = new URL(url);
            let titleResult = this.titleList.find((titleVal) => {
              return titleVal.url == url;
            });
            const fileName = titleResult
              ? titleResult.title
              : tmpUrl.pathname.split("/").pop();
            let fileElement = this.getContentEditorFileItem(url, "file", {
              file: {
                name: fileName,
              },
            });
            newText += tmp[0] + fileElement.outerHTML;
            lastPart = tmp[1];
            // let audio = new Audio();
            // audio.src = url;
            // audio.id = "audio" + eleIdx;
            // let id = new Date().getTime();
            // eleList.push({
            //   type: "audio",
            //   val: url,
            //   fileName: fileName,
            //   fileIcon: this.getFileIcon(fileName),
            //   id: id,
            // });
          } else {
            let tmpUrl = new URL(url);
            let titleResult = this.titleList.find((titleVal) => {
              return titleVal.url == url;
            });
            const fileName = titleResult
              ? titleResult.title
              : tmpUrl.pathname.split("/").pop();
            let fileElement = this.getContentEditorFileItem(url, "file", {
              file: {
                name: fileName,
              },
            });
            newText += tmp[0] + fileElement.outerHTML;
            lastPart = tmp[1];
            // let tmpUrl = new URL(url);
            // const fileName = tmpUrl.pathname.split("/").pop();
            // eleList.push({
            //   type: "file",
            //   val: url,
            //   fileName: fileName,
            //   fileIcon: this.getFileIcon(fileName),
            // });
          }
          // lastPart=tmp[1]
          let str = "";
          tmp.forEach((tmpItem, idx) => {
            if (idx) {
              str += tmpItem;
            }
          });
          lastPart = str;
        }
      }
      lastPart = newText + lastPart;
      eleList.push({
        type: "text",
        val: lastPart,
      });
      return eleList;
    },
    //获取元素数组的所有文本集合
    getEleListAllText(eleList) {
      // let text = "";
      // eleList.forEach((ele) => {
      //   if (ele.type == "text") {
      //     text += ele.val;
      //   }
      // });
      // return text;

      return eleList[eleList.length - 1].val;
    },
    // 提取文件后缀的辅助函数
    getFileExtension(url) {
      const path = url.split("/");
      const fileName = path[path.length - 1];
      const parts = fileName.split(".");

      if (parts.length > 1) {
        return parts.pop();
      }

      return "";
    },
    getVideoDuration(url) {
      let video = document.createElement("video");
      video.src = url;
      video.load();
      video.onload = () => {
        console.log("video==", video);
      };
    },
    getFileIcon(fileName) {
      let icon = "";
      if (fileName.includes(".doc")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png";
      } else if (fileName.includes(".txt")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png";
      } else if (fileName.includes(".xls")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png";
      } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png";
      } else if (fileName.includes(".pdf")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png";
      } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png";
      } else {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png";
      }
      return icon;
    },
    //滚轮左右滑动
    wheelHScroll(event) {
      event.preventDefault();
      // 根据滚轮的垂直滚动值设置水平滚动
      event.currentTarget.scrollLeft += event.deltaY;
    },
    //查询话术文件标题
    async qryHuashuListTitle(list) {
      return new Promise(async (resolve, reject) => {
        let params = {
          urlArray: JSON.stringify(list),
        };
        let resp = await this.$http.qryHuashuListTitle(params);
        if (resp.code == 200) {
          resolve(resp.data.array);
        } else {
          resolve([]);
        }
      });
    },
  },
  async created() {
    if (
      localStorage.getItem("localDataVersion") != this.$config.localDataVersion
    ) {
      localStorage.setItem("localDataVersion", this.$config.localDataVersion);
      // localStorage.clear();
      localStorage.removeItem("syncParamsList");
      await dbService.clearAllData();
      return;
    }

    if (false) {
      //去掉本地搜索
      await dbService.initDb();
      this.localHuashuListData = await dbService.getAllData("huashuList");
    }
    if (localStorage.getItem("huashuTopBarHide")) {
      this.huashuTopBarShow = false;
    }
    window.addEventListener("resize", () => {
      this.pageWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.pageHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    });
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
    this.userName = localStorage.getItem("edujia:group:web:userName");
    if (localStorage.getItem("edujia:group:web:token")) {
      this.$store.commit(
        "modifyToken",
        localStorage.getItem("edujia:group:web:token"),
      );
    }
    if (localStorage.getItem("typeListWidth")) {
      this.typeListWidth = localStorage.getItem("typeListWidth");
    }
  },
  mounted() {
    if (window.require) {
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("getSettingInfo");
      let _this = this;
      ipcRenderer.on("webLog", (event, logStr) => {
        this.$message("logStr:" + logStr);
      });
      ipcRenderer.on("getSettingInfoResp", (event, settingInfoStr) => {
        if (settingInfoStr) {
          _this.$store.commit("modifySettingInfo", JSON.parse(settingInfoStr));
        }
      });
      ipcRenderer.on("updateHuashuItem", (event, huashuItem) => {
        console.log("updateHuashuItem:", huashuItem);
        huashuItem.eleList = _this.generateEleList(huashuItem.speechText);
        huashuItem.imglist = huashuItem.eleList.filter((eleListItem) => {
          eleListItem.val = eleListItem.val.replace("http://", "https://");
          return eleListItem.type == "img" || eleListItem.type == "video";
        });
        huashuItem.filelist = huashuItem.eleList.filter((eleListItem) => {
          eleListItem.val = eleListItem.val.replace("http://", "https://");
          return eleListItem.type == "file" || eleListItem.type == "audio";
        });
        huashuItem.allText = _this.getEleListAllText(huashuItem.eleList);
        let resultIdx = -1;
        _this.huashuList.forEach((val, idx) => {
          if (huashuItem.id == val.id) {
            resultIdx = idx;
          }
        });
        // if (resultIdx != -1) {
        //   huashuItem.isTop = _this.huashuList[resultIdx].isTop;
        //   _this.huashuList.splice(resultIdx, 1, huashuItem);
        // } else if (huashuItem.isFront == 1) {
        //   _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem);
        // } else {
        //   _this.huashuList.splice(_this.huashuList.length, 0, huashuItem);
        // }
        if (resultIdx != -1) {
          huashuItem.isTop = _this.huashuList[resultIdx].isTop;
          _this.huashuList.splice(resultIdx, 1, huashuItem);
        } else if (huashuItem.isTop == 1 && huashuItem.isFront == 1) {
          _this.huashuList.splice(0, 0, huashuItem);
        } else if (huashuItem.isTop == 1 && huashuItem.isFront == 2) {
          _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem);
        } else if (huashuItem.isFront == 1) {
          _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem);
        } else {
          _this.huashuList.splice(_this.huashuList.length, 0, huashuItem);
        }

        // if(this.huashuListLoadend){
        //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
        // }
        _this.updateCellStyle();
      });
    }
    // this.$refs.topSubP.addEventListener("wheel", this.wheelHScroll);
    // this.$refs.bottomBarP.addEventListener("wheel", this.wheelHScroll);
  },
  activated() {
    if (localStorage.getItem("needReresh")) {
      this.typePage = 1;
      this.typeListLoadend = false;
      this.typeList = [];
      localStorage.removeItem("needReresh");
    }
    this.fetchData();
    // if (localStorage.getItem("updateHuashuItem")) {
    //     let huashuItem = JSON.parse(localStorage.getItem("updateHuashuItem"))
    //     huashuItem.eleList = this.generateEleList(huashuItem.speechText);
    //     huashuItem.imglist = huashuItem.eleList.filter((eleListItem) => {
    //         eleListItem.val = eleListItem.val.replace("http://", "https://")
    //         return eleListItem.type == 'img' || eleListItem.type == 'video'
    //     })
    //     huashuItem.filelist = huashuItem.eleList.filter((eleListItem) => {
    //         eleListItem.val = eleListItem.val.replace("http://", "https://")
    //         return eleListItem.type == 'file' || eleListItem.type == 'audio'
    //     })
    //     huashuItem.allText = this.getEleListAllText(huashuItem.eleList);
    //     let resultIdx = -1;
    //     this.huashuList.forEach((val, idx) => {
    //         if (huashuItem.id == val.id) {
    //             resultIdx = idx;
    //         }
    //     })
    //     if (resultIdx != -1) {
    //         huashuItem.isTop=this.huashuList[resultIdx].isTop;
    //         this.huashuList.splice(resultIdx, 1, huashuItem)
    //     } else if (huashuItem.isFront == 1) {
    //         this.huashuList.splice(this.countTopHuashu, 0, huashuItem)
    //     } else {
    //         this.huashuList.splice(this.huashuList.length, 0, huashuItem)
    //     }
    //     // if(this.huashuListLoadend){
    //     //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
    //     // }
    //     localStorage.removeItem("updateHuashuItem");
    //     this.updateCellStyle();
    // }
  },
};
</script>

<style>
.huashuListItemDetailShowmore .contentImgItem {
  margin-bottom: -20px !important;
}

.searching {
  width: 100%;
}

.contentImgItem {
  width: 110px;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin: 0 !important;
}

.contentImgItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.contentVideoPrviewItem {
  width: 110px;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin: 10px;
}

.contentVideoItem {
  width: 110px;
  height: 110px;
  position: relative;
  margin: 10px;
  background-color: #000;
}

.contentVideoItem video {
  width: 100%;
  height: 100%;
}

.contentVideoItemIcon {
  width: 44px !important;
  height: 44px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.contentFileItem {
  width: 350px;
  height: 70px;
  /* background-color: #fff; */
  /* background-color: #eee; */
  background-color: rgba(230, 230, 230);
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin: 10px;
  position: relative;
}

.contentFileItemIcon {
  width: 39px;
  height: 39px;
  margin-left: 20px;
}

.contentFileItemLabel {
  margin-left: 14px;
  width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: #3c3c3c;
}

html {
  background-color: #f5f6f6;
}

body {
  width: 1208px;
  margin: auto;
}

.el-dialog__body {
  padding: 10px 20px;
}

/* 隐藏垂直滚动条 */
::-webkit-scrollbar {
  width: 0;
}

/* 隐藏水平滚动条 */
::-webkit-scrollbar {
  height: 0;
}

.el-message-box {
  display: inline-block;
  width: 80%;
  min-width: 200px;
  /* max-width: 300px; */
  max-width: 580px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

#confirmInput {
  width: 500px;
  height: 24px;
  background-color: #f5f6f6;
  border: none;
  border-radius: 6px;
  padding: 23px 16px;
  font-size: 18px;
}

#confirmSwitch {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

#confirmSwitch img {
  width: 50px;
  height: 25px;
  margin-left: 20px;
}

#confirmSwitchClose {
  display: none;
}
</style>

<style scoped>
.topP {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.top {
  box-shadow: 0 2px 4px 0 #e5e5e58a;
  width: 100%;
  min-width: 200px;
  height: 64px;
  background-color: #fff;
}

.topBP {
  width: 1208px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}

.topB {
  width: 500px;
  height: 64px;
  background-color: #fff;
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.topSubP {
  width: 100%;
  height: 100%;
  /* overflow-x: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.topSub {
  display: flex;
  justify-content: space-between;
  width: 1208px;
}

.topLP {
  margin-left: 24px;
  font-size: 16px;
  color: #3c3c3c;
  font-weight: 500;
}

.topLLP {
  margin-left: 16px;
  display: flex;
  align-items: center;
  min-width: 120px;
}

.topLLP img {
  width: 48px;
  height: 48px;
}

.topLLP div {
  font-size: 20px;
  color: #3c3c3c;
  margin-left: 16px;
  font-weight: 500;
}

.topLLItem {
}

.topLLItemSel {
  color: #fb5d5c;
  font-size: 16px;
}

.topLLItemLine {
  width: 1px;
  height: 16px;
  background-color: #bdbdbd;
  margin-left: 16px;
  margin-right: 16px;
}

.topLLItem span {
  font-size: 14px;
  font-weight: 500;
}

.topLLItem div {
  width: 24px;
  height: 2px;
  border-radius: 2px;
  margin-top: 2px;
  background-color: #fb5d5c;
  margin: auto;
}

.topL {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.topLL {
  width: 20px;
  height: 20px;
  margin-left: 14px;
}

.topLR {
  font-size: 18px;
  font-weight: 500;
  color: #3c3c3c;
  margin-left: 8px;
  max-width: 150px;
  height: 32px;
  line-height: 32px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.topRP {
  display: flex;
  align-items: center;
  min-width: 170px;
}

.topRR2 {
  display: flex;
  align-items: center;
  font-size: 20px;
}

.topR {
  display: flex;
  align-items: center;
  /*    margin-right: 16px;*/
}

.topRL2 {
  width: 18px;
  height: 18px;
}

.topRL {
  font-size: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.topRL img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.topRR {
  margin-left: 8px;
  color: #4a90e2;
  font-size: 18px;
  /*    padding-right: 20px;*/
  /*    border-right: 1px solid #BDBDBD;*/
}

.content {
  display: flex;
  padding-top: 134px;
  height: calc(100vh - 134px);
}

.typeList {
  display: flex;
}

.typeListItem {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #f5f6f6;
  font-size: 16px;
  color: #3c3c3c;
  padding-left: 14px;
}

.typeListItem div {
  /*    width: 112px;*/
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.typeListItemSel {
  background-color: #fff;
  color: #fb5d5c;
  font-weight: 500;
}

.huashuListSearching {
  width: 952px !important;
  height: calc(100vh - 190px) !important;
  overflow: scroll;
  margin: auto;
}

.huashuList {
  /*    width: 77%;*/
  /* overflow: scroll; */
  flex: 1;
  position: relative;
  /* height: calc(100vh - 278px); */
  width: 992px;
}

.huashuListItemPP {
  height: calc(100vh - 278px);
  overflow: scroll;
}

.huashuListItemPP::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}

.huashuListItemPP::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background-color: lightgray !important;
  transition: 0.3s ease-in-out !important;
  margin: auto;
}

.huashuListItemP {
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.huashuListItemActionIcon {
}

.huashuListItemActionIcon img {
  width: 20px;
  height: 20px;
  margin-right: 16px;
}

.huashuListItem {
  width: 100%;
  padding: 8px 8px 8px 0px;
  padding-left: 8px;
  position: relative;
  border-bottom: 1px solid #e5e5e5;
}

.huashuListItemTop {
  display: flex;
  align-items: center;
}

.huashuListItemTopL {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

.huashuListItemTopM {
  /* margin-left: 4px; */
  /* margin-right: 8px; */
  font-size: 16px;
  font-weight: bold;
  color: #3c3c3c;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 90%;
  white-space: nowrap;
}

.huashuListItemTopMBig {
  font-size: 16px;
  font-weight: bold;
  margin-left: 0;
}

.huashuListItemTopR {
  margin-left: 4px;
  width: 24px;
  height: 24px;
}

.actionBtn {
  color: #4a90e2;
  font-size: 14px;
  border: 1px solid #4a90e2;
  background-color: #e6f2ff;
  border-radius: 4px;
  width: 60px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}

.actionBtn img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.huashuListItemDetailP {
  /* border-bottom: 1px solid #E5E5E5; */
  padding-bottom: 16px;
}

.huashuListItemDetail {
  font-size: 14px;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 20px;
  min-height: 20px;
  user-select: text !important;
}

.huashuListItemDetailShowmore {
  margin-top: 4px;
  font-size: 14px;
  white-space: pre-wrap;
  user-select: text !important;
  padding-bottom: 10px;
}

.huashuListItemDetailNoHide {
  margin-top: 4px;
  font-size: 14px;
  white-space: pre-wrap;
  position: fixed;
  left: 0;
  top: 0;
  opacity: 0;
  line-height: 20px;
  pointer-events: none;
}

.teamListCover {
  position: absolute;
  top: 128px;
  left: 50%;
  margin-left: -604px;
  width: 1208px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 8px 0 #e5e5e580;
  z-index: 1000;
  padding-bottom: 24px;
}

.teamListP {
  display: flex;
  justify-content: center;
}

.teamList {
  width: 89.74%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 10px;
}

.themeListCloseBtn {
  position: absolute;
  top: 22px;
  right: 15px;
  width: 20px;
  height: 20px;
}

.teamListItem {
  width: 18%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #f5f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #3c3c3c;
  font-size: 14px;
  flex-basis: calc(18% - 16px);
  /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
  margin: 10px;
  /* 添加间隔 */
  box-sizing: border-box;
  position: relative;
}

.teamListItem img {
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
}

.teamListItem div {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  overflow: hidden;
  text-align: center;
}

.teamListItemSel {
  border-color: #fb5d5c;
  background-color: #fff6f6;
  color: #fb5d5c;
}

.shouqiBtnP {
  display: flex;
  justify-content: center;
}

.shouqiBtn {
  color: #4a90e2;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: auto;
}

.shouqiBtn img {
  width: 14px;
  height: 8px;
  margin-left: 4px;
}

.huashuListItemDetailNoTitle {
  /*    padding-left: 23px;*/
  position: relative;
}

/*.huashuListItemDetailNoTitle::before{
    content: "";
    float: left;
    background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230804141713.png");
    background-repeat: no-repeat;
    background-size: 23px 14px;
    width: 23px;
    height: 14px;
}
*/
.imgTmp {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 0;
  top: 0;
}

.header-main-top {
  width: 38px;
  height: 38px;
  border-radius: 38px;
  margin-right: 14px;
  object-fit: cover;
}

.bottomBarP {
  width: 100%;
  height: 40px;
  /* overflow-x: scroll; */
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 999;
  position: absolute;
  left: 0;
  bottom: 0;
}

.bottomBar {
  width: 100%;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
}

.bottomBarL {
  display: flex;
  align-items: center;
}

.addTypeBtn {
  width: 86px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.addTypeBtn img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.addTypeBtn div {
  font-size: 14px;
  color: #4a90e2;
  line-height: 16px;
}

.addHuashuBtn {
  height: 40px;
  display: flex;
  align-items: center;
}

.addHuashuBtn img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.addHuashuBtn div {
  font-size: 14px;
  color: #4a90e2;
  line-height: 16px;
}

.psLbl {
  /* position: absolute;
        right: 16px;
        top: 12px; */
  font-size: 12px;
  color: #808080;
  line-height: 20px;
  margin-right: 16px;
}

.sizeBtn {
  width: 6px;
  border-radius: 7px;
  height: 50px;
  /*    background-color: red;*/
  display: flex;
  justify-content: space-evenly;
  pointer-events: none;
}

.sizeBtn div {
  width: 1px;
  height: 50px;
  background-color: lightgray;
}

.custom-resizer {
  width: 100%;
}

.layout-v > .multipane-resizer {
  width: 14px;
  height: 100%;
  margin-left: 0px;
  left: 0px;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  background-color: #fff;
  /*    border-left: 1px solid #eee;
    border-right: 1px solid #eee;*/
}

.searchAreaP {
  display: flex;
}

.searchArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.searchAreaBarTitle {
  font-size: 18px;
  font-weight: 500;
  margin-left: 24px;
  display: flex;
  align-items: center;
  height: 56px;
}

.searchAreaBarTitle img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.searchAreaBar {
  width: 240px;
  height: 32px;
  background-color: #f5f6f6;
  display: flex;
  align-items: center;
  margin-left: 16px;
  margin-right: 8px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
}

.searchAreaBar img {
  width: 14px;
  height: 14px;
  margin-left: 12px;
  margin-right: 8px;
}

.searchAreaBar input {
  width: 90%;
  padding-right: 12px;
  height: 18px;
  border: none;
  font-size: 13px;
  background-color: transparent;
}

.searchAreaBtn {
  width: 88px;
  height: 32px;
  background-color: #fb5d5c;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
}

.searchAreaCancelBtn {
  border: 1px solid #fb5d5c;
  background-color: #fff6f6;
  color: #fb5d5c;
}

.importHuashuBtn {
  height: 40px;
  display: flex;
  align-items: center;
  color: #4a90e2;
  font-size: 14px;
}

.importHuashuBtn img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  margin-left: 16px;
}

.topBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  background-color: #eeeeee;
  position: absolute;
  top: -1px;
  width: 100%;
  left: 0;
  z-index: 999 !important;
  /* box-shadow:1px 1px 5px 1px #dedede; */
}

.topBarL {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #3c3c3c;
  font-size: 13px;
  white-space: nowrap;
}

.topBarL img {
  width: 14px;
  height: 14px;
  margin-left: 9px;
  margin-right: 8px;
}

.topBarR {
  width: 15px;
  height: 14px;
  margin-right: 15px;
}

.chooseHuashuTypeList {
  max-height: 300px;
  overflow: scroll;
}

.macDownloadDialogContent {
  text-align: center;
  padding: 10px 0;
}

.macDownloadTip {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.macDownloadBtns {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.macDownloadBtn {
  width: 300px;
  height: 44px;
  font-size: 15px;
}

.searchingBar {
  position: absolute;
  left: 0;
  top: 100px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  padding-top: 16px;
}

.searchingBarIcon {
  width: 54px;
  height: 22px;
  margin-left: 8px;
  margin-right: 4px;
}

.faceBtn {
  margin-right: 8px;
  color: #4a90e2;
  display: flex;
  align-items: center;
}

.faceBtnlbl {
  margin-left: 2px;
  margin-top: -3px;
}

.searchBackBtn {
  width: 25px;
  height: 25px;
  margin-left: 20px;
}

.listTile {
  height: 56px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  font-size: 18px;
}

.listTile img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.listAdd2 {
  margin-left: 27px;
  margin-top: 23px;
}

.listAdd {
  display: flex;
  align-items: center;
  color: #4a90e2;
  font-size: 18px;
}

.listAdd img {
  width: 19px;
  height: 19px;
  margin-right: 8.5px;
}

.huashuEditDialogCover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.huashuEditDialogCoverMain {
  width: 1000px;
  height: 800px;
  position: relative;
  background-color: #fff;
}

.huashuDetailTitleP {
  width: 784px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
}

.huashuDetailTitleRight {
  margin-right: 16px;
  font-size: 18px;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.huashuDetailTitleRightL {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.huashuDetailTitleRightL img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.huashuDetailTitleRightR {
  margin-left: 40px;
  margin-right: 16px;
  font-size: 18px;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.huashuDetailTitleRightDot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #fb5d5c;
}

.huashuDetailTitle {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-left: 16px;
  height: 56px;
}

.huashuDetailTitle img {
  width: 20px;
  height: 19px;
  margin-right: 8px;
}

.huashuDetailTitleP2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
}

.huashuDetailTitleP2L {
  display: flex;
  margin-left: 16px;
}

.huashuDetailTitleP2R {
  display: flex;
  align-items: center;
  color: #4a90e2;
  margin-right: 16px;
}

.huashuDetailTitleP2R img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.huashuDetailTitleP2R div {
  font-size: 18px;
}

.actionBtn1 {
  width: 120px;
  height: 36px;
  background-color: #fb5d5c;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionBtn2 {
  width: 120px;
  height: 36px;
  background-color: #fff;
  color: #fb5d5c;
  border: 1px solid #fb5d5c;
  font-size: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 18px;
}

.listGray {
  height: calc(100vh - 238px);
  background-color: #f5f6f6;
  overflow: scroll;
}

.huashuPs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 11px;
}

.actionBar {
  display: flex;
  align-items: center;
}

.actionBarItem {
  color: #4a90e2;
  font-size: 16px;
  margin-right: 24px;
}

.huashuBatBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.huashuBatBarL {
  display: flex;
  align-items: center;
}

.huashuBatBarLL {
  color: #808080;
  font-size: 16px;
  margin-left: 16px;
  letter-spacing: 2px;
}

.huashuBatBarLR {
  color: #4a90e2;
  font-size: 16px;
  margin-left: 16px;
}

.huashuBatBarR {
}

.downloadBar {
  display: flex;
  align-items: center;
  height: 180px;
}

.downloadBarL {
  width: 50%;
  height: 142px;
}

.downloadBarL img {
  width: 129px;
  height: 129px;
  display: block;
  margin: auto;
}

.downloadBarL div {
  font-size: 18px;
  margin-top: 8px;
  text-align: center;
}

.downloadBarR {
  width: 50%;
  height: 142px;
}

.downloadBarR img {
  width: 129px;
  height: 129px;
  display: block;
  margin: auto;
}

.downloadBarR div {
  font-size: 18px;
  margin-top: 8px;
  text-align: center;
}

.downloadBarLine {
  width: 1px;
  height: 80px;
  background-color: #e5e5e5;
}

.teamIcon {
  width: 20px;
  height: 20px;
  background-color: #fb5d5c;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  margin-right: 4px;
}

.teamIcon2 {
  width: 20px;
  height: 20px;
  background-color: #43a046;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  margin-right: 4px;
}
</style>
